<template>
	<div id="enterprise_detail" class="">
		<leftnav class="fl" :haspagetitle="true"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<tableCharts ref="tableCharts" :chartType="chartType" :chartData="chartData"></tableCharts>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="enterprise_detail gov_enterprise_detail">
					<div class="whitebox centerpage">
						<div class="d_blocktitle">
							<i class="title-icon title-icon1"></i>
							<h3 class="ctitle">{{ companyinfor.title }}</h3>
							<!-- <p>{{companyinfor.addCRMid}}</p> -->
							<span
								:class="companyinfor.status == '注销' ? 'fl companystatus cancellation' : 'fl companystatus '">{{ companyinfor.status }}</span>
							<!-- 加入熟悉/想联系企业 带有园区大脑pid的不展示 3 20231229关闭熟悉想联系企业功能 -->
							<!-- <span v-if="!parkid" v-show="companyinfor.enterpriseRelationType != 2 " :class="companyinfor.enterpriseRelationId >0?'collectbtn remove fr ':'collectbtn add fr'" @click="toggleRelationEnterprise(companyinfor,1)" style="width:136px">{{companyinfor.enterpriseRelationId >0 ? '移除':'加入'}}我熟悉的企业</span> -->
							<!-- <span v-if="!parkid" class="collectbtn remove fr" v-show="companyinfor.enterpriseRelationType==2&&companyinfor.enterpriseRelationId >0" @click="toggleRelationEnterprise(companyinfor,2)"  style="width:136px">移除想联系的企业</span> -->
							<!-- 加入对比企业列表 所有版本都有 enterpriseComparisonId-->
							<span
								:class="companyinfor.enterpriseComparisonId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
								@click="togEnterpriseComparison(companyinfor.enterpriseComparisonId)">{{ companyinfor.enterpriseComparisonId
									== 0 ? '加入' : '移除'}}企业对比</span>
							<!-- 加入企业动态 带有园区大脑pid的和信贷大脑不展示  4 -->
							<div v-if="userdata.token">
								<span
								v-if="userdata.edition > 0 && userdata.operatList.jrqytzdt.btn && curWebsite.type != 4 && !parkid"
								:class="userEnterpriseId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
								@click="userenterpriseToggle();" style="width:136px">{{ userEnterpriseId ==
									0 ? '加入' : '移出'}}企业投资动态</span>
							<!-- 加入目标企业按钮  带有园区大脑pid的不展示   -->
							<span :class="companyinfor.collectId == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'"
								@click="collectFun()"
								v-if="userdata.operatList.jrmbqy.btn && !parkid">{{ companyinfor.collectId ==
									0 ? '加入目标企业' :'移出目标企业'}}</span>
							<!-- 项目管理按钮 带有园区大脑pid的和信贷大脑不展示 3 4  -->
							<span :class="addCRMid == 0 ? 'collectbtn add fr' : 'collectbtn remove fr'" @click="addtoCRM();"
								v-if="userdata.operatList.jrxmgl.btn && curWebsite.type != 4 && !parkid && userdata">{{ addCRMid ==
									0 ? '加入项目管理' :'移出项目管理'}}</span>
							</div>
							<!-- 页面下载报告按钮  带有园区大脑pid的不展示   -->
							<span v-show="enterprisedata1.unlock || lock" @click="download" v-if="topDownloadBtn"
								:class="{ 'fr enterprise-download': true, 'graynocur': !iframestus }"><i
									class="el-icon-download"></i>{{ iframestus ? ' 下载报告' : '下载中...' }}</span>
							<!-- 试用账户未解锁的下载报告按钮 带有园区大脑pid的不展示 3 pid-->
							<div class="fr" v-show="!enterprisedata1.unlock && !lock" v-if="topDownloadBtn">
								<span class="fl enterprise-download graynocur" title="解锁后下载报告"><i
										class="el-icon-lock"></i>下载报告</span><span @click="pagelockfun"
									class="fl enterprise-lockbtn"><i class="el-icon-key"></i>解锁</span>
							</div>
							<!-- 试用账户解锁提示弹框-->
							<div class="tipspopbox_bg" v-show="unlock">
								<div class="tipspopbox_acoc">
									<h4 class="numtips">目前剩余可解锁次数：<span
											class="num">{{ enterprisedata1.unlockRemainder }}</span></h4>
									<!--     background: linear-gradient(180deg,#fff8e9,#fff);-->
									<strong class="bluetips db">升级至正式版可获得全部访问权限</strong>
									<div class="btnbox">
										<span class="basebtn fl" @click="unlockfun()"><i class="loadingimg"
												v-show="lockopen"></i>{{ lockbtnfont }}</span>
										<span class="graybtn fr" @click="unlock = false">取消</span>
									</div>
									<span class="closebtn" @click="unlock = false"></span>
								</div>
							</div>
						</div>
						<ul class="oh conpany-infor-new">
							<li class="inforLine inforLine-3"><span class="label">注册资本：</span><span
									class="infortext">{{ companyinfor.regCapital }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">实缴资本：</span><span
									class="infortext">{{ companyinfor.paidCapital }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">组织机构代码：</span><span
									class="infortext">{{ companyinfor.orgCode }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">企业类型：</span><span
									class="infortext">{{ companyinfor.type }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">员工人数：</span><span
									class="infortext">{{ companyinfor.insurePerson > 0 ? companyinfor.insurePerson : '-' }}</span>
							</li>
							<li class="inforLine inforLine-3" v-show="companyinfor.isIpo"><span
									class="label">上市时间：</span><span class="infortext">{{ companyinfor.ipoTime }}</span>
							</li>
							<li class="inforLine inforLine-3" v-show="companyinfor.isIpo"><span
									class="label">A股代码：</span><span class="infortext">{{ companyinfor.stockCode }}</span>
							</li>
							<li class="inforLine inforLine-3" v-show="companyinfor.abbr"><span
									class="label">股票简称：</span><span class="infortext">{{ companyinfor.abbr }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">注册号：</span><span
									class="infortext">{{ companyinfor.regNo }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">纳税人识别号：</span><span
									class="infortext">{{ companyinfor.taxNo }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">所属行业：</span><span
									class="infortext">{{ companyinfor.industry }}</span></li>
							<li class="inforLine inforLine-3 longlabel" v-if="realController.length > 0"><span
									class="label">疑似实际控制人：</span><span
									class="infortext">{{ realController[0].title }}</span></li>
							<li class="inforLine inforLine-3" v-if="realController.length > 0"><span
									class="label">总股权比例：</span><span
									class="infortext">{{ realController[0].proportion }}</span></li>
							<li class="inforLine inforLine-one" v-show="extendinfor.coreProduct != ''"><span
										class="label">企业核心产品：</span>
										<el-tag effect="plain" class="mr-1" v-for="(item,i) in productlist" :key='i'>{{item }}</el-tag></li>
							<li class="inforLine inforLine-one" v-show="extendinfor.productName != ''"><span
									class="label">主营产品名称：</span><span
									class="infortext">{{ extendinfor.productName }}</span></li>
							<li class="inforLine inforLine-one" v-show="extendinfor.productType != ''"><span
									class="label">主营产品类型：</span><span
									class="infortext">{{ extendinfor.productType }}</span></li>
							<li class="inforLine inforLine-one" v-show="companyinfor.mainBusiness != ''"><span
									class="label">主营业务：</span><span
									class="infortext">{{ companyinfor.mainBusiness }}</span></li>
							<li class="inforLine inforLine-one" v-if="companyinfor.summary.length > 0"><span
									class="label">企业简介：</span><span class="infortext">{{ companyinfor.summary }}</span>
							</li>
						</ul>
						<div class="hidelongfont" v-if="companyinfor.businessScope != ''">
							<p class="companyinfor oneline">
								<i>经营范围：</i><em><b :key="i" v-for="(f, i) in companyinfor.businessScope"
										v-show="i <= businfontnum">{{ f }}</b>
									<b :class="businfontnum > defaultmainnum ? 'dn' : ''">……</b><b class="xqbtn curp"
										@click="editfontnum('busin')">{{ businfontnum >
											defaultmainnum ?'收起':'详情'}}</b></em>
							</p>
						</div>
						<div class="hidelongfont">
							<p class="companyinfor oneline" v-if="financing.length > 0 && financing[0].team != ''">
								<i>团队介绍：</i><em><b :key="i" v-for="(f, i) in financing[0].team"
										v-show="i <= teamfontnum">{{ f }}</b>
									<b v-show="financing[0].team.length > teamfontnum"
										:class="teamfontnum > defaultmainnum ? 'dn' : ''">……</b>
									<b class="xqbtn curp" v-show="financing[0].team.length > defaultmainnum"
										@click="editfontnum('team')">{{ teamfontnum > defaultmainnum ? '收起' : '详情' }}</b></em>
							</p>
						</div>
					</div>
					<div class="scroedetail centerpage" v-show="scoreDetail.length > 0 && showscroedetail">
						<div class="d_blocktitle">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">评分内容</h3>
						</div>
						<p v-if="leaderpagetype == 2">
							<span :key="index" v-for="(item, index) in scoreDetail"
								:class="item.description == '总分' ? 'basefont fwb' : ''">{{ item.description }}：{{ item.score }}</span>
						</p>
						<p v-if="leaderpagetype == 3">
							<span :key="index" v-for="(item, index)  in scoreDetail"
								v-if="index < scoreDetail.length - 1">{{ item.description }}：{{ item.score }}<em
									v-if="item.type != ''">({{ item.type }})</em></span>
							<span :key="index" v-for="(item, index) in scoreDetail" v-if="index == scoreDetail.length - 1"
								class="basefont fwb  db">{{ item.description }}={{ item.score }}</span>
						</p>
						<span class="closebtn" @click="showscroedetail = !showscroedetail">隐藏</span>
					</div>
					<div class="ende_floorlist">
						<div class="ende_floorlistfixed" :style="isCollapse ? 'width:100%;left:0' : ''">
							<ul class="oh">
								<!-- <li :key="index" v-for="(item,index) in floorlist" :class="curstepp == index ? 'current':''" 	@click="floorscroll(index)">{{item}}</li> -->
								<li class="floorlistLi" @click="floorscroll(0)">联系方式</li>
								<li class="floorlistLi" @click="floorscroll(1)" v-show="issucss">{{ curWebsite.hxname }}
								</li>
								<li class="floorlistLi" @click="floorscroll(2)" v-show="strategy.description != ''">战略方向
								</li>
								<li class="floorlistLi" @click="floorscroll(3)" v-show="companyinfor.tag != ''">实力标签</li>
								<li class="floorlistLi" @click="floorscroll(4)" v-show="companyinfor.notion != ''">所属产业</li>
								<li class="floorlistLi" @click="floorscroll(5)" v-show="mergeList.market.length != 0 || mergeList.compete.length != 0">产业数据</li>
								<li class="floorlistLi" @click="floorscroll(6)"
									v-show="yingyeshouru.data.length > 0 && netprofitlist.data.length > 0">经营状况</li>
								<li class="floorlistLi" @click="floorscroll(7)" v-show="changeLog.length > 0">变更记录</li>
								<li class="floorlistLi" @click="floorscroll(8)" v-show="relationship.length > 0">疑似关系</li>
								<li class="floorlistLi" @click="floorscroll(9)" v-show="sodataBtn">偿债能力</li>
								<li class="floorlistLi" @click="floorscroll(10)" v-show="financingRound.length > 0">融资信息
								</li>
								<li class="floorlistLi" @click="floorscroll(11)" v-show="supplierInfornum > 0">供应商</li>
								<li class="floorlistLi" @click="floorscroll(12)" v-show="customerInfornum > 0">客户</li>
								<li class="floorlistLi" @click="floorscroll(13)" v-show="landlist.length > 0">拿地信息</li>
								<li class="floorlistLi" @click="floorscroll(14)" v-show="projectList.length > 0">投资项目</li>
								<li class="floorlistLi" @click="floorscroll(15)" v-show="financeList.length > 0">融资项目</li>
								<li class="floorlistLi" @click="floorscroll(16)" v-show="investlist.length > 0">对外投资</li>
								<li class="floorlistLi" @click="floorscroll(17)" v-show="controllEnterprise.length > 0">控制企业</li>
								<li class="floorlistLi" @click="floorscroll(18)" v-show="shareholderlist.length > 0">股东信息</li>
								<li class="floorlistLi" @click="floorscroll(19)" v-show="keyPersonalList.length > 0">主要人员</li>
								<li class="floorlistLi" @click="floorscroll(20)" v-show="technologyList.length > 0">企业资质</li>
								<li class="floorlistLi" @click="floorscroll(21)" v-show="researchlist.length > 0">研发信息
								</li>
								<li class="floorlistLi" @click="floorscroll(22)"
									v-show="patentlist.length > 0 || companyinfor.patentNum > 0">专利信息</li>
								<li class="floorlistLi" @click="floorscroll(23)" v-show="softwareList.length > 0">软件著作权
								</li>
								<li class="floorlistLi" @click="floorscroll(24)" v-show="certificatelist.length > 0">资质证书
								</li>
								<li class="floorlistLi" @click="floorscroll(25)" v-show="eqpledgeBtn">股权质押</li>
								<li class="floorlistLi" @click="floorscroll(26)" v-show="riskinfobtn">风险预警</li>
								<li class="floorlistLi" @click="floorscroll(27)" v-show="newslist.length > 0">企业动态</li>
							</ul>
						</div>
					</div>
					<div class="whitebox company-contact	centerpage">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon2"></i>
							<h3 class="title">联系方式</h3>
							<vedioTips :type="7" class="fr"></vedioTips>
						</div>
						<ul class="oh conpany-infor-new">
							<li class="inforLine inforLine-3"><span class="label">法定代表人：</span><span
									class="infortext">{{ companyinfor.legalPerson }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">联系电话：</span><span
									class="infortext">{{ companyinfor.phone }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">更多电话：</span><span
									class="infortext">{{ companyinfor.morePhone }}</span></li>
							<li class="inforLine inforLine-3 com_website">
								<span class="label">网 址：</span>
								<span v-if="companyinfor.website.length > 3" @click="rwebsite = true"
									class="curp infortext">{{ enterpriseWebsite }}</span>
								<span class="infortext"
									v-if="companyinfor.website.length < 4">{{ companyinfor.website }}</span>
							</li>
							<li class="inforLine inforLine-3"><span class="label">联系邮箱：</span><span
									class="infortext">{{ companyinfor.email }}</span></li>
							<li class="inforLine inforLine-3"><span class="label">更多邮箱：</span><span
									class="infortext">{{ companyinfor.moreEmail }}</span></li>
							<li class="inforLine inforLine-one"><span class="label">企业地址：</span>
								<p class="infortext">
									<span>{{ companyinfor.address }}</span>
									<span class="gpsiconFont"
										@click="routerlinkid('/enterpriseSurroundMap', enterpriseid)">附近同行业企业</span>
								</p>
							</li>
						</ul>
						<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite = false">
							<div class="enprise_website">
								<h2>您即将跳转进入第三方网站</h2>
								<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
								<p class="website_text"><a :href="enterpriseWebsite"
										target="_blank">{{ enterpriseWebsite }}</a></p>
								<a class="router_website" :href="enterpriseWebsite" target="_blank">继续前往</a>
							</div>
						</div>
						<localRelatedEnterprisea :compData="localRelatedEnterprise" :isFree="userdata.groupType == 2" :currentCity="userdata.currentCity"
							v-if="scrollbtn"></localRelatedEnterprisea>
					</div>
					<div v-show="issucss">
						<div class="whitebox company-tags	centerpage "
							v-show="companyinfor.collectType != 16 && isradar">
							<div class=" d_blocktitle d-floortitle">
								<i class="title-icon title-icon3"></i>
								<h3 class="title">{{ curWebsite.hxname }}</h3>
								<vedioTips :type="5" class="fr"></vedioTips>
							</div>
							<div class="enterprise_zsldt flexcss">
								<ul>
									<li @click="getranderdata('none', item.code);"
										:class="zsldnav == item.code ? 'navbg' : ''" :key="i"
										v-for="(item, i) in randerpagedata.notionList">
										<span
											style="display: inline-block;width: 100%;height: 100%;">{{ item.name }}</span>
									</li>
								</ul>
								<div id="enterprise_zsldtchart"></div>
								<div class="zsldt_tablebox">
									<div class="enterprise_zsldtable1" id="invest-algorithm">
										<div class="enterprise_zsldt_tabletitle">
											<span>{{ curWebsite.type == 4 ? '投资（融资）可能性算法' : '投资可能性算法' }}</span>
											<el-tooltip class="item smartTip-text" effect="light"
												placement="right-start">
												<i class="el-icon-question"
													style="color:cornflowerblue;margin-left: 5px;"></i>
												<div slot="content" class="list_tips">
													<p style="font-size: 14px;">
														在同一企业类型的分数排名中，0＜分数≤25%的企业为A，25%＜分数≤60%的企业为B，60%＜分数≤100%的企业为C。
													</p>
												</div>
											</el-tooltip>
										</div>
										<div class="">
											<!-- <enterpriseNotionGrade v-if="ldtname.length>0" :listData="ldtname" :ldtNotion="randerpagedata.notion.name"></enterpriseNotionGrade> -->
											<table border="0" cellspacing="0" cellpadding="0" class=" zsldt_pagetable1"
												width="100%" v-if="ldtname.length > 0">
												<tr>
													<th colspan="3">{{ randerpagedata.notion.name }}-总体评分</th>
													<th colspan="4">{{ ldtname[0].value.toFixed(2) }}</th>
												</tr>
												<tr>
													<td colspan="2">分析要素</td>
													<td> 说明</td>
													<td> 得分</td>
													<td> 级别</td>
													<td> 得分说明</td>
												</tr>
												<tr>
													<td rowspan="2">企业</td>
													<td>{{ ldtname[1].text }}</td>
													<td class="font-kt"> 有实力投</td>
													<td> {{ ldtname[1].value }}</td>
													<td> {{ ldtname[1].level }}</td>
													<td class="text_al font-kt"> {{ ldtname[1].summary }}</td>
												</tr>
												<tr>
													<td>{{ ldtname[2].text }}</td>
													<td class="font-kt"> 实际在投</td>
													<td> {{ ldtname[2].value }}</td>
													<td> {{ ldtname[2].level }}</td>
													<td class="text_al font-kt"> {{ ldtname[2].summary }}</td>
												</tr>
												<tr>
													<td rowspan="2">行业</td>
													<td>{{ ldtname[3].text }}</td>
													<td class="font-kt"> 有机会投</td>
													<td> {{ ldtname[3].value }}</td>
													<td> {{ ldtname[3].level }}</td>
													<td class="text_al font-kt"> {{ ldtname[3].summary }}</td>
												</tr>
												<tr>
													<td>{{ ldtname[4].text }}</td>
													<td class="font-kt"> 被鼓励投</td>
													<td> {{ ldtname[4].value }}</td>
													<td> {{ ldtname[4].level }}</td>
													<td class="text_al font-kt"> {{ ldtname[4].summary }}</td>
												</tr>
											</table>
										</div>
									</div>
									<div class="enterprise_zsldtable2" v-show="randerdata.length > 0">
										<div class="enterprise_zsldt_tabletitle">
											<span>{{ curWebsite.type == 4 ? '本省投资（融资）关联度算法' : '本省投资关联度算法' }}</span>
											<el-tooltip class="item smartTip-text" effect="light"
												placement="right-start">
												<i class="el-icon-question"
													style="color:cornflowerblue;margin-left: 5px;"></i>
												<div slot="content" class="list_tips">
													<p style="font-size: 14px;">排名1-3名的省份为A，排名4-6名的省份为B，排名7名及以后的省份为C。
													</p>
												</div>
											</el-tooltip>
										</div>
										<table border="0" cellspacing="0" cellpadding="0" class=" zsldt_pagetable1"
											width="100%">
											<!-- <tr style="background: rgb(248, 251, 254);">
							<th ><span >排名</span></th>
							<th><span >省份</span></th>
							<th><span>本省关联度</span></th>   
						</tr> -->
											<!-- <tr :key="i" v-for="(item,i) in randerdata">
								<td>{{item.rank}}</td>
								<td>{{item.name}}</td> 
								<td>{{getnum(item.value)}}</td>  
							</tr> -->
											<tr>
												<th>排名</th>
												<td :key="i" v-for="(item, i) in randerdata">{{ item.rank }}</td>
											</tr>
											<tr>
												<th>省份</th>
												<td :key="i" v-for="(item, i) in randerdata">{{ item.name }}</td>
											</tr>
											<tr>
												<th>本省关联度</th>
												<td :key="i" v-for="(item, i) in randerdata">{{ getGrade(i + 1) }}</td>
											</tr>
										</table>
									</div>
									<table border="0" cellspacing="0" cellpadding="0" class="zsldt_pagetable1"
										width="100%" v-if="ldtname.length > 0 && ldtname[5].value > 0">
										<tr>
											<td>投资地点</td>
											<td>{{ userdata.provinceText }}关联度</td>
											<!-- <td class="font-kt">来本省投</td> -->
											<!-- <td> {{ldtname[5].value}}</td> -->
											<td> {{ ldtname[5].level }}</td>
											<td class="text_al font-kt">{{ ldtname[5].summary }}</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="whitebox company-tags	centerpage"
						v-show="strategy.description != '' || strategy.keywords != ''">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">战略方向</h3>
							<vedioTips :type="5" class="fr"></vedioTips>
						</div>
						<div class="company_tag_list">
							<div class="oh endetail_taglist" v-show="strategy.keywords != ''">
								<h5 class="title fl">关键词</h5>
								<div class="fl"><span class="span-tag-n" :key="index"
										v-for="(item, index) in strategy.keywords">{{ item }} </span></div>
							</div>
							<div class="oh endetail_taglist" v-show="strategy.description != ''">
								<h5 class="title fl">描&nbsp;&nbsp;述</h5>
								<div class="fl">
									<p class="span-tag-n" :key="index" v-for="(item, index) in strategy.description">
										{{ item + '。' }}</p>
								</div>
							</div>
							<div class="flexcss">
								<div class="oh endetail_taglist widthPC-20 border-none" v-show="extendinfor.strategyText != ''">
									<h5 class="title fl">战略态势</h5>
									<div class="fl">
										<p class="span-tag-n">
											{{extendinfor.strategyText }}</p>
									</div>
								</div>
								<div class="oh endetail_taglist widthPC-40 border-none" v-show="extendinfor.operateText != ''">
									<h5 class="title fl">经营状况</h5>
									<div class="fl">
										<p class="span-tag-n" >
											{{ extendinfor.operateText }}</p>
									</div>
								</div>
								<div class="oh endetail_taglist widthPC-40 border-none" v-show="extendinfor.site !=''">
									<h5 class="title fl">选址逻辑</h5>
									<div class="fl">
										<p class="span-tag-n" v-for="item in extendinfor.siteListArry" :key="item.type">
                                            {{ item.name }}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="whitebox company-tags	centerpage" v-show="companyinfor.tag.length > 0">
						<div class="d_blocktitle d-floortitle" id="company-tag">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">实力标签</h3>
							<vedioTips :type="6" class="fr"></vedioTips>
						</div>
						<div class="company_tag_list" :data='companyinfor.tag'>
							<!-- <span class="span-tag" :key="index" v-for="(item,index) in companyinfor.taglist"  @click="tagrouter('/enterpriseTag',leaderpagetype,'tag',item.id,item.name)">{{item.name}}</span> -->
							<!-- <div class="oh endetail_taglist" :key="ind" v-for="(list,ind) in tagtreelist" v-if="list.taglist.length>0 && list.name!='投资实力'">
							<h5 class="title fl">{{list.name}}</h5>
							<div class="fl"><span class="span-tag" :key="index" v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'enterprisedetial')">{{item.name}}</span></div> 
						</div>  
						<div class="oh endetail_taglist"  v-if="tagtreelist1[0].taglist.length>0">
							<h5 class="title fl">投资实力</h5>
							<div class="fl">
								<p :key="ind" v-for="(list,ind) in tagtreelist1" class="oh"><span class="span-tag" :key="index" v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'enterprisedetial')">{{item.name}}</span></p>
								</div> 
						</div> -->
							<enterpriseTaglist v-if="companyinfor.tag != ''" :tagText="companyinfor.tag"
								:tag-code="companyinfor.tagCode"></enterpriseTaglist>
							<div class="oh endetail_taglist" v-show="associationList.length > 0">
								<h5 class="title fl">所属协会</h5>
								<div class="fl"><span class="span-tag" :key="index"
										v-for="(item, index) in associationList"
										@click="routerlinkid('/associationDetail', item.id)">{{ item.title }}</span></div>
							</div>
							<div class="oh endetail_taglist" v-show="commerceList.length > 0">
								<h5 class="title fl">所属商会</h5>
								<div class="fl"><span class="span-tag" :key="index" v-for="(item, index) in commerceList"
										@click="routerlinkid('/commerceDetail', item.id)">{{ item.title }}</span></div>
							</div>
						</div>
					</div>
					<div class="whitebox company-tags	centerpage" v-show="companyinfor.notion != ''">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">所属产业</h3>
							<vedioTips :type="5" class="fr"></vedioTips>
						</div>
						<div class="company_tag_list">
							<span class="span-tag" :key="index" v-for="(item, index) in companyinfor.notionlist"
								@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'enterprisedetial')">{{ item.name }}</span>
						</div>
					</div>
					<div class="whitebox company-tagscenterpage" v-show="mergeList.market.length != 0 || mergeList.compete.length != 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">产业数据</h3>
						</div>
						<mergeListCharts :mergeList="mergeList" :isFree="userdata.groupType == 2" ></mergeListCharts>
					</div>
					<div class="whitebox company-management centerpage"
						v-show="netprofitlist.data.length > 0 && yingyeshouru.data.length > 0">
						<div class="d_blocktitle d-floortitle" id="jyzk">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">经营状况</h3>
							<div class="pl-10 ml-8"><vedioTips :type="6" ></vedioTips>	</div>
							
							<div class="fr" style="margin-left:20px;padding-top:4px">
								<span v-show="!enterprisedata1.unlock && !lock" class="fr enterprise-download "
									title="解锁后下载报告" @click="pagelockfun"><i class="el-icon-lock"></i>解锁报告</span>
								<span v-show="enterprisedata1.unlock || lock" @click="downloadFinanceReport"
									:class="{ 'fr enterprise-download': true, 'graynocur': !iframestus1 }"><i
										class="el-icon-download"></i>{{ iframestus1 ? '下载报告' : '下载中...' }}</span>
							</div>
							<a class="curp fr" target="_blank" :href="stocklist.url"
								v-if="!demonstrate && curWebsite.type != 7">{{ stocklist.text }}</a>
						</div>
						<div class="oh  jyzkdiv">
							<div class="fl" :style="'width:' + echartWidth2 + 'px;'">
								<div class="echartbox1" :style="'width:' + echartWidth2 + 'px;'" id="jyzk_radar"></div>
								<div class="echartbox1" :style="'width:' + echartWidth2 + 'px;'" id="jyzk_radarfont"
									v-html="stocklist.html"></div>
							</div>
							<div class="fl">
								<div class="echartbox" :style="'width:' + echartWidth2 + 'px;'" id="businessincome"></div>
								<div class="echartbox" :style="'width:' + echartWidth2 + 'px;'" id="netprofit"></div>
							</div>
						</div>
						<!-- 主营构成分析 -->
						<zhuyinggoucheng :data="mainBusiness" v-if="scrollbtn"></zhuyinggoucheng>
					</div>
					<!--变更记录  -->
					<div class="whitebox company-investinfor" v-show="changeLog.length > 0">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">变更记录</h3>
						</div>
						<h4 class="endsm_title w95mg">迁址记录</h4>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>变更日期</th>
								<th>变更项目</th>
								<th>变更前</th>
								<th>变更后</th>
							</tr>
							<tr :key="i" v-for="(list, i) in changeLog">
								<td>{{ i + 1 }}</td>
								<td>{{ list.date }}</td>
								<td>{{ list.type }} </td>
								<td>{{ list.changeBefore }}</td>
								<td>{{ list.changeAfter }}</td>
							</tr>
						</table>
					</div>
					<!-- 疑似关系 -->
					<div class="whitebox company-investinfor" v-show="relationship.length > 0">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon "></i>
							<h3 class="title">疑似关系</h3>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>企业名称</th>
								<th>地区</th>
								<th>法定代表人</th>
								<th>注册资本</th>
								<th>成立日期</th>
								<th>疑似关系类型</th>
								<th>疑似关系详情</th>
							</tr>
							<tr :key="i" v-for="(list, i) in relationship">
								<td>{{ i + 1 }}</td>
								<td><span v-if="list.stockCode == ''">{{ list.title }}</span><span class="curp"
										v-if="list.stockCode != ''"
										@click="routerlinkid('/enterprises', list.stockCode)">{{ list.title }}</span></td>
								<td>{{ emptyStr(list.area) }}</td>
								<td>{{ list.legalPerson }}</td>
								<td>{{ list.regCapital }}</td>
								<td>{{ list.createTime }}</td>
								<td>{{ list.type }}</td>
								<td>{{ list.detail }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="sodataBtn">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon7"></i>
							<h3 class="title">偿债能力</h3>
						</div>
						<solvency :sodata="solvency" v-if="sodataBtn"></solvency>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="financingRound.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">融资信息</h3>
						</div>
						<p style="margin-bottom: 10px;" class="w95mg" v-if="financingRound.length > 0"><b
								class="orange_font">{{ companyinfor.title }}</b>完成<b class="orange_font"><span
									v-if="financingRound.length > 0">{{ financingRound[0].rount }}</span></b>融资
							<span v-if="financing[0].amount != '-' && financingRound.length > 0">，融资次数<b
									class="orange_font">{{ financing[0].number }}</b>次</span>。
						</p>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>融资轮次</th>
								<th>融资时间</th>
								<th>融资金额</th>
								<th>投资方</th>
								<th>融资总次数</th>
								<!-- <th>融资总额</th> -->
								<!-- <th>估值</th> -->
							</tr>
							<tr :key="index" v-for="(item, index) in financingRound">
								<td>{{ index + 1 }}</td>
								<td>{{ item.rount }}</td>
								<td>{{ item.time }}</td>
								<td>{{ item.amount }}</td>
								<td class="orglist">
									<span :key="inds" v-for="(dd, inds) in item.orgList"
										@click="detailrouterto('/investement-enterprises', dd.id)"
										:class="dd.id != 0 ? 'curp' : ''" :data="dd.id">{{ dd.orgName }}<i
											v-if="inds != item.orgList.length - 1">、</i></span>
								</td>
								<td v-if="index == 0" :rowspan="financingRound.length">{{ financing[0].number }}</td>
								<!-- <td v-if="index == 0" :rowspan="financingRound.length">{{financing[0].amount}}</td> -->
								<!-- <td v-if="index == 0" :rowspan="financingRound.length">{{financing[0].valuation}}</td> -->
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="supplierInfornum > 0" id="supplier">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">供应商</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<p class="w95mg" style="margin-bottom: 10px;" v-if="supplierInfornum > 0"><b
								class="orange_font">{{ companyinfor.title }}</b>供应商信息<b
								class="orange_font">{{ supplierInfornum }}</b>条
							<span v-if="supplierArea.length > 0">，数量分布最多的城市是<b class="orange_font"
									v-if="supplierArea.length > 0">{{ supplierArea[0].name == '其他' ? supplierArea[1].name : supplierArea[0].name }}</b>，
								占<b class="orange_font"
									v-if="supplierArea.length > 0">{{ supplierArea[0].name == '其他' ? supplierArea[1].percent.toFixed(2) : supplierArea[0].percent.toFixed(2) }}%</b></span>。
						</p>
						<div class="w95mg" v-show="supplierArea.length > 0">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 fl"
								:style="'width:' + echartWidth2 + 'px;'">
								<tr>
									<!-- <th>省份</th>
							<th>数量</th>
							<th>占比</th> -->
									<th style="width:220px">城市</th>
									<th>数量</th>
									<th>占比</th>
								</tr>
								<tr :key="ind" v-for="(list, ind) in supplierArea" v-if="list.name != '其他'">
									<td>{{ list.name }}</td>
									<td>{{ list.value }}</td>
									<td>{{ list.percent.toFixed(2) }}%</td>
								</tr>
								<tr :key="ind" v-for="(list, ind) in supplierArea" v-if="list.name == '其他'">
									<td>{{ list.name }}</td>
									<td>{{ list.value }}</td>
									<td>{{ list.percent.toFixed(2) }}%</td>
								</tr>
							</table>
							<div id="gys_pie" class="fr" :style="'width:' + echartWidth2 + 'px;'"></div>
						</div>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>日期</th>
									<th>供应商名称</th>
									<th>地区</th>
									<th>采购额(万元)</th>
									<th>备注</th>
								</tr>
								<tr :key="i" v-for="(item, i) in supplier" v-if="i < 5">
									<td>{{ i + 1 }}</td>
									<td>{{ item.yearText }}</td>
									<td>
										<span v-if="item.stockCode == ''">{{ item.name }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="userdata.city == item.areaId ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.name }}</span>
									</td>
									<td><span
										:class="userdata.city == item.areaId ? 'curp current' : 'curp'">{{ item.area }}</span>
									</td>
									<td>{{ item.purchaseAmount == "" ? '-' : item.purchaseAmount }}</td>
									<td>
										<span v-show="item.children < 1">-</span>
										<span v-show="item.children.length > 0" class="curp"
											@click="supplycustomerMore(item)">全部{{ item.children.length + 1 }}条信息></span>
									</td>
								</tr>
							</table>
							<p class="lockfont" v-show="supplierInfornum > 5">点击&nbsp;<span class="basefont fontb"
									@click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>

						</div>
						<div :class="showsuppliernum < supplierInfornum ? 'demandlist_hide_table showmorenode' : 'demandlist_hide_table'"
							style="clear: both;" v-if="enterprisedata1.unlock || lock">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg"
								v-show="supplierInfornum > 0">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>日期</th>
									<th>供应商名称</th>
									<th>地区</th>
									<th>采购额(万元)</th>
									<th>备注</th>
									<!-- <th>采购占比(%)</th> -->
								</tr>
								<tr :key="i" v-for="(item, i) in supplier" v-if="i < showsuppliernum">
									<td>{{ i + 1 }}</td>
									<td>{{ item.yearText }}</td>
									<td>
										<span v-if="item.stockCode == ''">{{ item.name }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="userdata.city == item.areaId ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.name }}</span>
									</td>
									<td><span
											:class="userdata.city == item.areaId ? 'curp current' : 'curp'">{{ item.area }}</span>
									</td>
									<td>{{ item.purchaseAmount == "" ? '-' : item.purchaseAmount }}</td>
									<td>
										<span v-show="item.children < 1">-</span>
										<span v-show="item.children.length > 0" class="curp"
											@click="supplycustomerMore(item)">全部{{ item.children.length + 1 }}条信息></span>
									</td>
									<!-- <td>{{item.purchasePercent==""?'-':item.purchasePercent}}</td> -->
								</tr>
							</table>
							<div class="showmorenodebtn" @click="contorlpatent('sp')" v-show="supplierInfornum > 100">
								<span v-show="showsuppliernum >= supplierInfornum">向上隐藏</span>
								<span v-show="showsuppliernum < supplierInfornum">共{{ supplierInfornum }}条信息 点击加载更多>></span>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="customerInfornum > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">客户</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<p class="w95mg" style="margin-bottom: 10px;" v-if="customerInfornum > 0"><b
								class="orange_font">{{ companyinfor.title }}</b>有客户信息<b
								class="orange_font">{{ customerInfornum }}</b>条
							<span v-if="customerArea.length > 0"> ，数量分布最多的城市是<b class="orange_font"
									v-if="customerArea.length > 0">{{ customerArea[0].name == '其他' ? customerArea[1].name : customerArea[0].name }}</b>，占<b
									class="orange_font"
									v-if="customerArea.length > 0">{{ customerArea[0].name == '其他' ? customerArea[1].percent.toFixed(2) : customerArea[0].percent.toFixed(2) }}%</b></span>。
						</p>
						<div class="w95mg" v-show="customerArea.length > 0">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 fl"
								:style="'width:' + echartWidth2 + 'px;'">
								<tr>
									<th style="width:220px">城市</th>
									<th>数量</th>
									<th>占比</th>
								</tr>
								<tr :key="ind" v-for="(list, ind) in customerArea" v-if="list.areaId > 0">
									<td>{{ list.name }}</td>
									<td>{{ list.value }}</td>
									<td>{{ list.percent.toFixed(2) }}%</td>
								</tr>
								<tr :key="ind" v-for="(list, ind) in customerArea" v-if="list.areaId == 0">
									<td>{{ list.name }}</td>
									<td>{{ list.value }}</td>
									<td>{{ list.percent.toFixed(2) }}%</td>
								</tr>
							</table>
							<div id="kh_pie" class="fr" :style="'width:' + echartWidth2 + 'px;'"></div>
						</div>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>日期</th>
									<th>客户名称</th>
									<th>地区</th>
									<th>销售额(万元)</th>
									<th>备注</th>
									<!-- <th>销售占比(%)</th> -->
								</tr>
								<tr :key="i" v-for="(item, i) in customer" v-if="i < 5">
									<td>{{ i + 1 }}</td>
									<td>{{ item.yearText }}</td>
									<td>
										<span v-if="item.stockCode == ''">{{ item.name }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="userdata.city == item.areaId ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.name }}</span>
									</td>
									<td><span
										:class="userdata.city == item.areaId ? 'curp current' : 'curp'">{{ item.area }}</span>
									</td>
									<td>{{ item.salesAmount == "" ? '-' : item.salesAmount }}</td>
									<td>
										<span v-show="item.children < 1">-</span>
										<span v-show="item.children.length > 0" class="curp"
											@click="supplycustomerMore(item)">全部{{ item.children.length + 1 }}条信息></span>
									</td>
									<!-- <td>{{item.salesPercent==""?'-':item.salesPercent}}</td> -->
								</tr>
							</table>
							<p class="lockfont" v-show="customerInfornum > 5">点击&nbsp;<span class="basefont fontb"
									@click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
						</div>
						<div :class="showcustomernum < customerInfornum ? 'demandlist_hide_table showmorenode' : 'demandlist_hide_table'"
							style="clear: both;" v-if="enterprisedata1.unlock || lock">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg"
								v-show="customerInfornum > 0">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>日期</th>
									<th>客户名称</th>
									<th>地区</th>
									<th>销售额(万元)</th>
									<th>备注</th>
									<!-- <th>销售占比(%)</th> -->
								</tr>
								<tr :key="i" v-for="(item, i) in customer" v-if="i < showcustomernum">
									<td>{{ i + 1 }}</td>
									<td>{{ item.yearText }}</td>
									<td>
										<span v-if="item.stockCode == ''">{{ item.name }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="userdata.city == item.areaId ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.name }}</span>
									</td>
									<td><span
										:class="userdata.city == item.areaId ? 'curp current' : 'curp'">{{ item.area }}</span>
									</td>
									<td>{{ item.salesAmount == "" ? '-' : item.salesAmount }}</td>
									<td><span v-show="item.children < 1">-</span><span v-show="item.children.length > 0"
											@click="supplycustomerMore(item)"
											class="curp">全部{{ item.children.length + 1 }}条信息></span></td>
									<!-- <td>{{item.salesPercent==""?'-':item.salesPercent}}</td> -->
								</tr>
							</table>
							<div class="showmorenodebtn" @click="contorlpatent('cu')" v-show="customerInfornum > 100">
								<span v-show="showcustomernum >= customerInfornum">向上隐藏</span>
								<span v-show="showcustomernum < customerInfornum">共{{ customerInfornum }}条信息 点击加载更多>></span>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="landlist.length > 0">
						<div class="d_blocktitle d-floortitle" id="land-map-block">
							<i class="title-icon title-icon9"></i>
							<h3 class="title">拿地信息</h3>
							<vedioTips :type="1" class="fr"></vedioTips>
						</div>
						<p style="margin-bottom: 10px;" class="w95mg" v-if="landlist.length > 0"><b
								class="orange_font">{{ companyinfor.title }}及其下属公司</b>共有拿地纪录<b
								class="orange_font">{{ landlist.length }}</b>条，拿地面积达<b
								class="orange_font">{{ landInfo.sizeCount.toFixed(2) }}</b>亩，成交金额达<b
								class="orange_font">{{ landInfo.moneyCount }}</b>万元
							。拿地数量最多的年份是<b class="orange_font">{{ landInfo.numMaxYear }}年</b>，拿地面积最大的年份是<b
								class="orange_font">{{ landInfo.sizeMaxYear }}年</b>，成交金额最高的年份是<b
								class="orange_font">{{ landInfo.moneyMaxYear }}年</b>。</p>
						<div class="w95mg flexcss" style="padding-top:20px">
							<div class="landMapInforbox fl por">
								<div class="land-map-title">
									<h5 :class="landMapType == 1 ? 'current title fl' : 'title fl'"
										@click="landMapEchart(1, '拿地面积区域分布')">拿地面积区域分布</h5>
									<h5 :class="landMapType == 2 ? 'current title fl' : 'title fl'"
										@click="landMapEchart(2, '拿地数量区域分布')">拿地数量区域分布</h5>
								</div>
								<div id="landMapInfor"></div>
							</div>
							<div class="fr" style="width: 40%;" id="land-pie-block">
								<div class="oh land-ecahrt-title">
									<h5 :class="landEchartType == 1 ? 'current title fl' : 'title fl'"
										@click="landEchart(1, '历年拿地面积')">历年拿地面积</h5>
									<h5 :class="landEchartType == 2 ? 'current title fl' : 'title fl'"
										@click="landEchart(2, '历年拿地数量')">历年拿地数量</h5>
									<h5 :class="landEchartType == 3 ? 'current title fl' : 'title fl'"
										@click="landEchart(3, '近期拿地面积')">近期拿地面积</h5>
									<h5 :class="landEchartType == 4 ? 'current title fl' : 'title fl'"
										@click="landEchart(4, '近期拿地数量')">近期拿地数量</h5>
								</div>
								<div class="deepseek-land-ecahrt">
									<div id="nadixinxi-line"></div>
									<div class="deeseek-tips"><span class="orgfont">让deepseek做企业拿地数据和投资趋势分析：</span> 
										<em class="curp" @click="goAIChart(1,1)">快速分析 >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>
										<em class="curp" @click="goAIChart(1,2)">深度分析 ></em> 
									</div>
								</div>
								
								<div id="nadixinxi-pie"></div>
								
							</div>
						</div>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>行政区域</th>
									<th>项目名称</th>
									<th>总面积（亩）</th>
									<th>总金额（万元）</th>
									<th>土地用途</th>
									<th>土地使用权人</th>
									<th>拿地时间</th>
								</tr>
								<tr :key="index" v-for="(item, index) in landlist" v-if="index < 5">
									<td>{{ index + 1 }}</td>
									<td>{{ item.area }}</td>
									<td><span :class="(item.url && item.url != '') ? 'curp' : ''"
											@click="openProjectLink(item.url)">{{ item.projectName }}</span></td>
									<td>{{ item.size.toFixed(2) }}<!-- {{item.sizeUnit}} --></td>
									<td>{{ item.amount }}<!-- {{item.amountUniut}} --></td>
									<td>{{ item.purpose }}</td>
									<td>
										<span @click="routerlinkid('/enterprises', item.stockCode)"
											:class="item.stockCode ? 'curp' : ''">{{ item.owner }}</span>
									</td>
									<td>{{ item.time }}</td>
								</tr>
							</table>
							<p class="lockfont" v-show="landlist.length > 5">点击&nbsp;<span class="basefont fontb"
									@click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1"
							v-if="enterprisedata1.unlock || lock">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>行政区域</th>
								<th>项目名称</th>
								<th>总面积（亩）</th>
								<th>总金额（万元）</th>
								<th>土地用途</th>
								<th>土地使用权人</th>
								<th>拿地时间</th>
							</tr>
							<tr :key="index" v-for="(item, index) in landlist">
								<td>{{ index + 1 }}</td>
								<td>{{ item.area }}</td>
								<td><span :class="(item.url && item.url != '') ? 'curp' : ''"
										@click="openProjectLink(item.url)">{{ item.projectName }}</span></td>
								<td>{{ item.size.toFixed(2) }}<!-- {{item.sizeUnit}} --></td>
								<td>{{ item.amount }}<!-- {{item.amountUniut}} --></td>
								<td>{{ item.purpose }}</td>
								<td>
									<span @click="routerlinkid('/enterprises', item.stockCode)"
										:class="item.stockCode ? 'curp' : ''">{{ item.owner }}</span>
								</td>
								<td>{{ item.time }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="projectList.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon"></i>
							<h3 class="title">投资项目</h3>
							<vedioTips :type="1" class="fr"></vedioTips>
						</div>
						<div style="margin-bottom: 10px;" class="w95mg">
							<p><b class="orange_font">{{ companyinfor.title }}</b>共有投资项目<b
									class="orange_font">{{ projectInfo.count }}</b>个（特指1000万以上项目），总金额达<b
									class="orange_font">{{ projectInfo.moneyCount }}</b>万元。主要分布在<b
									class="orange_font">{{ projectInfo.cityMax }}</b>，占比<b
									class="orange_font">{{ projectInfo.cityMaxPercent }}</b>，投资次数最多的年份是<b
									class="orange_font">{{ projectInfo.numMaxYear }}年</b>，投资金额最大的年份是<b
									class="orange_font">{{ projectInfo.moneyMaxYear }}年</b>。</p>
						</div>
						<div class="w95mg flexcss" style="padding-top:20px">
							<div class="landMapInforbox fl por">
								<div class="land-map-title">
									<h5 :class="projectMapType == 1 ? 'current title fl' : 'title fl'"
										@click="projectMapEchart(1, '项目金额区域分布')">项目金额区域分布</h5>
									<h5 :class="projectMapType == 2 ? 'current title fl' : 'title fl'"
										@click="projectMapEchart(2, '项目数量区域分布')">项目数量区域分布</h5>
								</div>
								<div id="projectMapInfor"></div>
							</div>
							<div class="fr" style="width: 40%;">
								<div class="oh land-ecahrt-title">
									<h5 :class="projectEchartType == 1 ? 'current title fl' : 'title fl'"
										@click="projectEchart(1, '历年项目金额')">历年项目金额</h5>
									<h5 :class="projectEchartType == 2 ? 'current title fl' : 'title fl'"
										@click="projectEchart(2, '历年项目数量')">历年项目数量</h5>
									<h5 :class="projectEchartType == 3 ? 'current title fl' : 'title fl'"
										@click="projectEchart(3, '近期项目金额')">近期项目金额</h5>
									<h5 :class="projectEchartType == 4 ? 'current title fl' : 'title fl'"
										@click="projectEchart(4, '近期项目数量')">近期项目数量</h5>
								</div>
								<div id="touzixiangmu-line"></div>
								<div id="touzixiangmu-pie"></div>
							</div>
						</div>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>公司名称</th>
									<th>项目名称</th>
									<th>金额（万）</th>
									<th>时间</th>
								</tr>
								<tr :key="index" v-for="(item, index) in projectList" v-if="index < 5">
									<td>{{ index + 1 }}</td>
									<td>{{ item.title }}</td>
									<td><span :class="(item.url && item.url != '') ? 'curp' : ''"
											@click="openProjectLink(item.url)">{{ item.projectName }}</span></td>
									<td>{{ item.money }}</td>
									<td>{{ item.date }}</td>
								</tr>
							</table>
							<p class="lockfont" v-show="projectList.length > 5">点击&nbsp;<span class="basefont fontb"
									@click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1"
							v-if="enterprisedata1.unlock || lock">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>公司名称</th>
								<th>项目名称</th>
								<th>金额（万）</th>
								<th>时间</th>
							</tr>
							<tr :key="index" v-for="(item, index) in projectList">
								<td>{{ index + 1 }}</td>
								<td>{{ item.title }}</td>
								<td><span :class="(item.url && item.url != '') ? 'curp' : ''"
										@click="openProjectLink(item.url)">{{ item.projectName }}</span></td>
								<td>{{ item.money }}</td>
								<td>{{ item.date }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="financeList.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon"></i>
							<h3 class="title">融资项目</h3>
							<vedioTips :type="1" class="fr"></vedioTips>

						</div>
						<div style="margin-bottom: 10px;" class="w95mg">
							<p><b class="orange_font">{{ companyinfor.title }}</b>共有融资项目<b
									class="orange_font">{{ financeList.length }}</b>个，总金额达<b
									class="orange_font">{{ financeTotalMoney }}</b>万元。</p>
						</div>
						<div class="w95mg">
							<div class="oh land-ecahrt-title">
								<h5 :class="financeEchartType == 1 ? 'current title fl' : 'title fl'"
									@click="financeChart(1, '历年融资金额')">历年融资金额</h5>
								<h5 :class="financeEchartType == 2 ? 'current title fl' : 'title fl'"
									@click="financeChart(2, '历年融资数量')">历年融资数量</h5>
								<h5 :class="financeEchartType == 3 ? 'current title fl' : 'title fl'"
									@click="financeChart(3, '近期融资金额')">近期融资金额</h5>
								<h5 :class="financeEchartType == 4 ? 'current title fl' : 'title fl'"
									@click="financeChart(4, '近期融资数量')">近期融资数量</h5>
							</div>
							<div id="rzxm-line" class="echart-line-box" :style="'width:' + echartWidth3 + 'px;'"></div>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th>序号</th>
								<th>公告标题</th>
								<th>公司名称</th>
								<th>股票代码</th>
								<th>行业</th>
								<th>融资金额(万元)</th>
								<th>日期</th>
							</tr>
							<tr v-for="(list, index) in financeList" :key="index">
								<td class="paixu">{{ index + 1 }}</td>
								<td :style="list.title.length < 20 ? 'white-space: nowrap;' : ''">{{ list.title }}</td>
								<td>
									<span v-if="list.stockCode == enterpriseid">{{ list.enterprise }}</span>
									<span @click="routerlinkid('/enterprises', list.stockCode)"
										v-if="list.stockCode != enterpriseid">{{ list.enterprise }}</span>
								</td>
								<td><span>{{ list.stockCode }}</span></td>
								<td>{{ list.industry }}</td>
								<td>{{ list.money }}{{ list.unit }}</td>
								<td>{{ list.date }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="investlist.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">对外投资</h3>
							<vedioTips :type="1" class="fr"></vedioTips>

						</div>
						<p style="margin-bottom: 10px;" class="w95mg"><b
								class="orange_font">{{ companyinfor.title }}</b>共有对外投资<b
								class="orange_font">{{ investlist.length }}</b>个。</p>
						<investLinePie v-if="investlist.length > 0" :data="investChart" :detailType="2" :showPie="true"
							:showLine="true"></investLinePie>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1" width="100%">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>被投资企业名称</th>
									<th>地区</th>
									<th>法定代表人</th>
									<th>注册资本</th>
									<th>投资比例</th>
									<th>投资数额</th>
									<th>成立时间</th>
									<th>状态</th>
								</tr>
								<tr :key="index" v-for="(item, index) in investlist" v-if="index < 10">
									<td>{{ index + 1 }}</td>
									<td>
										<span v-if="item.stockCode == ''" class=" ">{{ item.title }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="item.area == userdata.currentCity.text ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.title }}</span>
									</td>
									<td><span
											:class="userdata.currentCity.text == item.area ? 'curp current' : ''">{{ item.area == "" ? '-' : item.area }}</span>
									</td>
									<td>{{ item.legalPerson }}</td>
									<td>{{ item.regCapital }}</td>
									<td>{{ item.proportion }}%</td>
									<td>{{ item.investAmount }}</td>
									<td>{{ item.createTime }}</td>
									<td>{{ item.status }}</td>
								</tr>
							</table>
							<p class="lockfont" v-show="investlist.length > 10">点击&nbsp;<span class="basefont fontb"
									@click="pagelockfun"><i class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1"
							v-if="enterprisedata1.unlock || lock">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>被投资企业名称</th>
								<th>地区</th>
								<th>法定代表人</th>
								<th>注册资本</th>
								<th>投资比例</th>
								<th>投资数额</th>
								<th>成立时间</th>
								<th>状态</th>
							</tr>
							<tr :key="index" v-for="(item, index) in investlist">
								<td>{{ index + 1 }}</td>
								<td>
									<span v-if="item.stockCode == ''" class=" ">{{ item.title }}</span>
									<span v-if="item.stockCode != ''"
										@click="detailrouterto('/enterprises', item.stockCode)"
										:class="item.area == userdata.currentCity.text ? 'curp current' : 'curp'"
										:data="item.stockCode">{{ item.title }}</span>
								</td>
								<td><span
										:class="userdata.currentCity.text == item.area ? 'curp current' : ''">{{ item.area == "" ? '-' : item.area }}</span>
								</td>
								<td>{{ item.legalPerson }}</td>
								<td>{{ item.regCapital }}</td>
								<td>{{ item.proportion }}%</td>
								<td>{{ item.investAmount }}</td>
								<td>{{ item.createTime }}</td>
								<td>{{ item.status }}</td>
							</tr>
						</table>
					</div>

					<div class="whitebox company-investinfor centerpage" v-show="controllEnterprise.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon8"></i>
							<h3 class="title">控制企业</h3>
						</div>
						<p style="margin-bottom: 10px;" class="w95mg" v-if="controllEnterprise.length > 0"><b
								class="orange_font">{{ companyinfor.title }}</b>共有控制企业<b
								class="orange_font">{{ controllEnterprise.length }}</b>个</p>
						<investLinePie v-if="controllEnterprise.length > 0" :data="controllEntChart" :detailType="3"
							:showPie="true" :showLine="false"></investLinePie>
						<div class="locktable w95mg" v-if="enterprisedata1.unlock == false && lock == false">
							<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>控制企业</th>
									<th>地区</th>
									<th>投资比例</th>
									<th>投资链</th>
								</tr>
								<tr :key="index" v-for="(item, index) in controllEnterprise" v-if="index < 10">
									<td>{{ index + 1 }}</td>
									<td>
										<span v-if="item.stockCode == ''" class=" ">{{ item.title }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="item.area == userdata.currentCity.text ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.title }}</span>
									</td>
									<td><span
											:class="userdata.currentCity.text == item.area ? 'curp current' : ''">{{ item.area == "" ? '-' : item.area }}</span>
									</td>
									<td><span>{{ item.proportion }}</span></td>
									<td>
										<span class="db tal">{{ item.investChain }}</span>
									</td>
								</tr>
							</table>
							<p class="lockfont" v-show="controllEnterprise.length > 10">点击&nbsp;<span
									class="basefont fontb" @click="pagelockfun"><i
										class="el-icon-key"></i>解锁</span>&nbsp;查看完整信息</p>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1"
							v-if="enterprisedata1.unlock || lock">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>控制企业</th>
								<th>地区</th>
								<th>投资比例</th>
								<th>投资链</th>
							</tr>
							<tr :key="index" v-for="(item, index) in controllEnterprise">
								<td>{{ index + 1 }}</td>
								<td>
									<span v-if="item.stockCode == ''" class=" ">{{ item.title }}</span>
									<span v-if="item.stockCode != ''"
										@click="detailrouterto('/enterprises', item.stockCode)"
										:class="item.area == userdata.currentCity.text ? 'curp current' : 'curp'"
										:data="item.stockCode">{{ item.title }}</span>
								</td>
								<td><span
										:class="userdata.currentCity.text == item.area ? 'curp current' : ''">{{ item.area == "" ? '-' : item.area }}</span>
								</td>
								<td><span>{{ item.proportion }}</span></td>
								<td>
									<span class="db tal">{{ item.investChain }}</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="shareholderlist.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon4"></i>
							<h3 class="title">股东信息</h3>
						</div>
						<p style="margin-bottom: 10px;" class="w95mg" v-if="shareholderlist.length > 0">共<b
								class="orange_font">{{ shareholderlist.length }}</b>位股东，最大的股东是<b
								class="orange_font">{{ shareholderlist[0].name }}</b>，持股比例为<b
								class="orange_font">{{ shareholderlist[0].value }}%</b>。</p>
						<div class="w95mg flexcss">
							<table border="0" cellspacing="0" cellpadding="0" width="50%" class="pagetable1 gdxx-h">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>股东及出资信息</th>
									<th>地区</th>
									<th>持股比例</th>
									<th>持股数(股)</th>
								</tr>
								<tr :key="index" v-for="(item, index) in shareholderlist">
									<td>{{ index + 1 }}</td>
									<td>
										<span v-if="item.stockCode == ''" class=" ">{{ item.name }}</span>
										<span v-if="item.stockCode != ''"
											@click="detailrouterto('/enterprises', item.stockCode)"
											:class="item.area == userdata.currentCity.text ? 'curp current' : 'curp'"
											:data="item.stockCode">{{ item.name }}</span>
									</td>
									<td><span
											:class="userdata.currentCity.text == item.area ? 'curp current' : ''">{{ item.area == "" ? '-' : item.area }}</span>
									</td>
									<td>{{ item.value }}%</td>
									<td>{{ item.number }}</td>
								</tr>
							</table>
							<div class="" id="detail_sharholder" style="width: 48%;"></div>
							<p style="clear: both;" v-show="companyinfor.isIpo">
								注：上市公司的小比例投资机构、散户投资者在表中不显示，故上表持股比例和低于100%。</p>
						</div>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="keyPersonalList.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon4"></i>
							<h3 class="title">主要人员</h3>
						</div>
						<div class="w95mg">
							<keyPersonal :keyPersonalList="keyPersonalList"></keyPersonal>
						</div>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="technologyList.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon6"></i>
							<h3 class="title">科技型企业资质</h3>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" width="100%" class="pagetable1 w95mg">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>名称</th>
								<th>编号</th>
								<th>资质类型</th>
								<th>级别</th>
								<th>来源</th>
								<th>发布单位</th>
								<th>发布日期</th>
								<th>有效期自</th>
								<th>有效期至</th>
							</tr>
							<tr :key="index" v-for="(item, index) in technologyList">
								<td>{{ index + 1 }}</td>
								<td>{{ item.title }}</td>
								<td>{{ item.number }}</td>
								<td>{{ item.qualificationType }}</td>
								<td>{{ item.level }}</td>
								<td>{{ item.source }}</td>
								<td>{{ item.publishUnit }}</td>
								<td>{{ item.publishDate }}</td>
								<td>{{ item.validFrom }}</td>
								<td>{{ item.validTo }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="researchlist.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon6"></i>
							<h3 class="title">研发信息
								<div class="deeseek-tips font-normal display-inline-block ml-5"><span class="orgfont">让deepseek做企业研发投入和创新能力分析：</span> 
									<em class="curp" @click="goAIChart(3,1)">快速分析 >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>
									<em class="curp" @click="goAIChart(3,2)">深度分析 ></em> 
								</div>
							</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<p class="w95mg" style="margin-bottom: 10px;" v-if="researchlist.length > 0"><b
								class="orange_font" v-show="researchlist.length > 0">{{ companyinfor.title }}<span
									v-if="researchlist.length > 0">{{ researchlist[0].year }}</span>年</b>研发人员数量达<b
								class="orange_font"><span
									v-if="researchlist.length > 0">{{ researchlist[0].num }}</span></b>人，
							占员工数量的<b class="orange_font"><span
									v-if="researchlist.length > 0">{{ researchlist[0].numPercent }}</span>%</b>，研发支出合计<b
								class="orange_font"><span
									v-if="researchlist.length > 0">{{ (researchlist[0].expend / 10000).toFixed(1) }}</span>万元</b>，占营业收入的<b
								class="orange_font" v-if="researchlist.length > 0">{{ researchlist[0].expendPercent }}%</b>。
						</p>
						<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg"
							v-show="researchlist.length > 0">
							<tr>
								<th style="width: 150px;">时间</th>
								<th>研发人员数量<i class="icon icon-bar-chart cur-pointer" @click="handlerChart('researchlist','num','bar')"></i></th>
								<th>研发人员数量占比<i class="icon icon-line-chart cur-pointer"  @click="handlerChart('researchlist','numPercent','line')"></i></th>
								<th>研发支出合计（万元）<i class="icon icon-bar-chart cur-pointer"  @click="handlerChart('researchlist','expend','bar')"></i></th>
								<th>研发支出总额占营业收入比例<i class="icon icon-line-chart cur-pointer"  @click="handlerChart('researchlist','expendPercent','line')"></i></th>
							</tr>
							<tr :key="ind" v-for="(list, ind) in researchlist">
								<td>{{ list.year }}</td>
								<td>{{ list.num == 0 ? '-' : list.num }}</td>
								<td>{{ list.numPercent == 0 ? '-' : list.numPercent }}%</td>
								<td>{{ (list.expend / 10000).toFixed(1) }}</td>
								<td>{{ list.expendPercent == 0 ? '-' : list.expendPercent }}%</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="patentlist.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon6"></i>
							<h3 class="title">最新专利 
								<div class="deeseek-tips font-normal display-inline-block ml-5"><span class="orgfont">让deepseek做企业专利数据和技术实力分析：</span> 
									<em class="curp" @click="goAIChart(2,1)">快速分析 >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>
									<em class="curp" @click="goAIChart(2,2)">深度分析 ></em> 
								</div>
								</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<!-- <div class="oh" style="margin-bottom: 30px;" v-show="companyinfor.patentNum>0">
					<p class="companyinforN oh companyinfor5"> 
						<span class="fl"><i>专利量：</i><em>{{companyinfor.patentNum}}</em></span> 
						<span class="fl"><i>发明（设计）人数量：</i><em>{{companyinfor.inventionNum}}</em></span> 
						<span class="fl"><i>有效专利量：</i><em>{{companyinfor.validPatentNum}}</em></span> 
						<span class="fl"><i>有效发明专利数量（件）：</i><em>{{companyinfor.validInventionNum}}</em></span> 
						<span class="fl"><i>有效实用新型数量（件）：</i><em>{{companyinfor.validPracticalNewTypeNum}}</em></span> 
					</p>
					<p class="companyinforN oh companyinfor5"> 
						<span class="fl"><i>有效外观设计数量（件）：</i><em>{{companyinfor.validFacadeDesignNum}}</em></span> 
						<span class="fl"><i>发明公开专利总量：</i><em>{{companyinfor.inventionPublicPatentNum}}</em></span> 
						<span class="fl"><i>外观设计专利总量：</i><em>{{companyinfor.facadeDesignPatentNum}}</em></span> 
						<span class="fl"><i>实用新型专利总量：</i><em>{{companyinfor.practicalNewTypePatentCount}}</em></span> 
					</p> 
				</div> -->
						<patentLinePie v-if="investlist.length > 0" :data="patentlist" :showPie="true" :showLine="true">
						</patentLinePie>
						<div
							:class="showzhuanlinum < patentlist.length ? 'demandlist_hide_table showmorenode' : 'demandlist_hide_table'">
							<!-- v-if="enterprisedata1.unlock || lock" -->
							<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
								<tr>
									<th class="xuhaotd">序号</th>
									<th>发明名称</th>
									<th>专利类型</th>
									<th>法律状态</th>
									<th>申请号</th>
									<th>申请日</th>
									<th>公开(公告)号</th>
									<th>公开(公告)日期</th>
									<th>发明人</th>
								</tr>
								<tr :key="index" v-for="(item, index) in patentlist" v-if="index < showzhuanlinum">
									<td>{{ index + 1 }}</td>
									<td>{{ item.title }}</td>
									<td>{{ item.type }}</td>
									<td>{{ item.legalStatus }}</td>
									<td>{{ item.pubNo }}</td>
									<td>{{ item.appDate }}</td>
									<td>{{ item.appNo }}</td>
									<td>{{ item.pubDate }}</td>
									<td>{{ item.inventor }}</td>
								</tr>
							</table>
							<div class="showmorenodebtn" @click="contorlpatent('zl')"
								v-show="patentlist.length > 100 && enterprisedata1.unlock">
								<span v-show="showzhuanlinum >= patentlist.length">向上隐藏</span>
								<span v-show="showzhuanlinum < patentlist.length">共{{ patentlist.length }}条信息
									点击加载更多>></span>
							</div>
						</div>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="softwareList.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon6"></i>
							<h3 class="title">软件著作权</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<div class="oh w95mg">
							<div class="fl echart-line-box" :style="'width:' + echartWidth2 + 'px;'" id="zzq-line-echart">
							</div>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="pagetable1 w95mg">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>软件全称</th>
								<th>版本号</th>
								<th>登记号</th>
								<th>开发完成日期</th>
								<th>首次发布日期</th>
								<th>登记日期</th>
								<th>权力取得方式</th>
							</tr>
							<tr :key="index" v-for="(item, index) in softwareList">
								<td>{{ index + 1 }}</td>
								<td>{{ item.title }}</td>
								<td>{{ item.version }}</td>
								<td>{{ item.regNo }}</td>
								<td>{{ item.completeDate }}</td>
								<td>{{ item.publishDate }}</td>
								<td>{{ item.regDate }}</td>
								<td>{{ item.authType }}</td>
							</tr>
						</table>
					</div>
					<div class="whitebox company-investinfor centerpage" v-show="certificatelist.length > 0">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon5"></i>
							<h3 class="title">资质证书</h3>
							<vedioTips :type="6" class="fr"></vedioTips>	
						</div>
						<p class="w95mg" style="margin-bottom: 10px;"><b
								class="orange_font">{{ companyinfor.title }}</b>拥有资质证书共<b
								class="orange_font">{{ certificatelist.length }}</b>种。</p>
						<div class="oh w95mg">
							<div class="fl echart-line-box" :style="'width:' + echartWidth2 + 'px;'" id="zzzs-line-echart">
							</div>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>证书类型</th>
								<th>证书名称</th>
								<th>证书编号</th>
								<th>发证日期</th>
								<th>截止日期</th>
							</tr>
							<tr :key="index" v-for="(item, index) in certificatelist">
								<td>{{ index + 1 }}</td>
								<td>{{ item.certType }}</td>
								<td class="toolongtd">{{ item.certName }}</td>
								<td>{{ item.certNo }}</td>
								<td>{{ item.startDate }}</td>
								<td>{{ item.endDate }}</td>
							</tr>
						</table>
					</div>
					<equityPledge title="股权质押" v-if="eqpledgeBtn" :hasdata="eqpledgeBtn" :stockcode="enterpriseid"
						:isipo="companyinfor.isIpo" :companyname="companyinfor.abbr" :blockdata="secondData">
					</equityPledge>
					<div class="whitebox company-tags	centerpage dn" v-if="!eqpledgeBtn">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">股权质押</h3>
						</div>
					</div>
					<riskInfo title="风险预警" v-if="riskinfobtn" :hasdata="riskinfobtn"
						:executedPerson="secondData.executedPerson" :judgmentDoc="secondData.judgmentDoc"
						:breakPromise="secondData.breakPromise" :judicialCase="secondData.judicialCase"
						:limitExpense="secondData.limitExpense" :isFree='userdata.isFree'></riskInfo>
					<div class="whitebox company-tags	centerpage dn" v-if="!riskinfobtn">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">风险预警</h3>
						</div>
					</div>
					<div class="whitebox company-tags	centerpage" v-show="newslist.length > 0 && userdata.token">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">企业动态</h3>
						</div>
						<div class="detailNewlist oh w95mg flexcss">
							<li :key="ind" v-for="(list, ind) in newslist" @click="routerlinkid(list.url, list.id, 2)">
								<span class="pushtime">{{ list.publishTime }}</span><span
									class="title">{{ list.title }}</span></li>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 供应商客户查看更多弹框 -->
		<div class="tipspopbox_bg" v-if="sucuDataPop">
			<div class="tipspopbox_sucudata">
				<span class="closebtn" @click="sucuDataPop = false"></span>
				<table border="0" cellspacing="0" cellpadding="0" class="pagetable1">
					<tr>
						<th class="xuhaotd">序号</th>
						<th>日期</th>
						<th>供应商名称</th>
						<th>地区</th>
						<th>采购额(万元)</th>
					</tr>
					<tr>
						<td>1</td>
						<td>{{ sucuData.yearText }}</td>
						<td>
							<span v-if="sucuData.stockCode == ''">{{ sucuData.name }}</span>
							<span v-if="sucuData.stockCode != ''"
								@click="detailrouterto('/enterprises', sucuData.stockCode)" class="curp" :class="userdata.city == item.areaId ? 'curp current' : 'curp'"
								:data="sucuData.stockCode" style="white-space: nowrap;">{{ sucuData.name }}</span>
						</td>
						<td :class="userdata.city == item.areaId ? 'curp current' : 'curp'">{{ sucuData.area }}</td>
						<td>{{ sucuData.purchaseAmount == "" ? '-' : sucuData.purchaseAmount }}</td>
					</tr>
					<tr :key="i" v-for="(item, i) in sucuData.children">
						<td>{{ i + 2 }}</td>
						<td>{{ item.yearText }}</td>
						<td>
							<span v-if="item.stockCode == ''">{{ item.name }}</span>
							<span v-if="item.stockCode != ''" @click="detailrouterto('/enterprises', item.stockCode)"
								class="curp" :data="item.stockCode" style="white-space: nowrap;">{{ item.name }}</span>
						</td>
						<td>{{ item.area }}</td>
						<td>{{ item.purchaseAmount == "" ? '-' : item.purchaseAmount }}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import zhuyinggoucheng from "../enterpriseInc/zhuyinggoucheng.vue"
import localRelatedEnterprisea from "../enterpriseInc/localRelatedEnterprise.vue"
import investLinePie from "../enterpriseInc/investLinePie.vue"
import enterpriseTaglist from "@/components/enterpriseInc/enterprise-tag-list.vue"
import enterpriseNotionGrade from "@/components/enterpriseInc/enterprise-notion-grade.vue"
import patentLinePie from "@/components/enterpriseInc/patentLinePie.vue"
import mergeListCharts from "@/components/enterpriseInc/mergeListCharts.vue"
import keyPersonal from "@/components/enterpriseInc/keyPersonnel.vue"
import vedioTips from "@/components/inc/vedio-tips.vue"

import { mapState, mapMutations, mapGetters } from "vuex";
import { extend } from "jquery"

export default {
	name: 'enterprise_detail',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			companyinfor: { website: "", tag: "", summary: "", },
			userdata: {}, curWebsite: this.$api.getWebsiteType(), curindex: 2, websiteName: "产业招商大脑", downloadurl: '', enterpriseWebsite: "",
			topDownloadBtn: false,
			guidelink: '', guidepage: '', echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48, secondData: [],
			riskinfobtn: false,
			eqpledgeBtn: false,
			riskInfoData: { executedPerson: [], judgmentDoc: [], breakPromise: [], judicialCase: [], limitExpense: [] },
			echartWidth1: document.body.offsetWidth * 0.8728 * 0.95,
			echartWidth3: document.body.offsetWidth * 0.8728 * 0.95 * 0.6,
			lockopen: false, lockbtnfont: '确定解锁',
			leaderpagetype: 0,
			userEnterpriseId: 0,//企业投资动态的企业id
			enterpriseid: 0, parkid: 0,
			leaderpage: "",
			investlist: [],
			landlist: [],
			demonstrate: this.$api.demonstrate(),
			cursors: { cursor: 'not-allowed' },
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
			zhaoshangjihui: { areaChoice: "" },

			extendinfor: { productName: "", productType: "",siteListArry:[] },
			certificatelist: [],
			patentlist: [],
			zsldnav: 0,
			showzhuanlibtn: 1,
			showsupplierbtn: 1,
			showcustomerbtn: 1,
			showzhuanlinum: 100,
			showsuppliernum: 100,
			showcustomernum: 100,
			showlandnum: 5,
			showprojectnum: 5,
			showinvestlistnum: 10,
			showcontrollenterprisenum: 10,
			defaultmainnum: 60,
			mainfontnum: 60,
			sumfontnum: 60,
			businfontnum: 60,
			teamfontnum: 60,
			shareholderlist: [],
			financingRound: [],
			financing: [{ amount: '', team: "" }],
			scoreDetail: [],
			showscroedetail: false,
			controllEnterprise: [],
			realController: [],
			researchlist: [],
			customer: [],//客户
			supplier: [],//供应商
			curstepp: 0,
			rwebsite: false,
			yingyeshouru: { data: [], date: [] },
			netprofitlist: { data: [], date: [] },
			newslist: [],
			leadingheader: [
				{ type: 1, name: '龙头企业招商', curindex: 2 },
				{ type: 2, name: '同行业企业库', curindex: 3 },
				{ type: 3, name: '战略投资者', curindex: 3 },
				{ type: 4, name: '大型企业库', curindex: 5 },
				{ type: 5, name: '龙头企业合作', curindex: 2 },
			],
			innovativeheader: [
				{ type: 1, name: '创新企业招商', curindex: 3 },
				{ type: 2, name: '投资标的', curindex: 4 },
				{ type: 3, name: '同行企业库', curindex: 5 },
				{ type: 4, name: '投资标的推荐', curindex: 2 },
				{ type: 5, name: '新兴企业合作', curindex: 3 },
			],
			tagarrylist: [
				{
					name: "综合实力", taglist: [],
					children: ['2021全球独角兽', '世界500强（内资）', '世界500强（外资）', '中国500强', '央企', '国有企业', '中国民营企业500强', '中国制造业民营企业500强',
						'中国服务业民营企业500强', '重点企业', '标杆企业', '知名企业', '猎豹企业', '独角兽企业', '瞪羚企业', '雏鹰企业', '隐形冠军企业', '牛羚企业', '上市公司', '主板上市公司',
						'科创板上市公司', '中小板上市公司', '创业板上市公司', '港股、美股上市公司', '北交所上市公司', '新上市', '预备上市', '新三板上市公司', '战略性新兴产业领军企业100强',
						'专精特新中小企业', '科技小巨人企业', '专精特新小巨人企业', '创新型企业', '科技型中小企业', '民营科技企业', '企业技术中心', '科技企业孵化器', '技术创新示范企业', '技术先进型服务企业',
						'省级专精特新企业', '省级专精特新小巨人企业', '高新技术企业', '华为系', '字节系', '腾讯系', '阿里系', '百度系', '京东系', '美团系', '小米系']
				},
				{ name: "技术实力", taglist: [], children: ['国家科技支撑计划', '国家科技重大专项', '国家标准起草单位', '国家薪火项目', '国家级科学技术进步奖', '国家地方联合工程研究中心', '国家重大科学仪器设备开发专项', '国家级工业设计中心', '高新技术企业研发中心', '企业国家重点实验室', '认定企业技术中心', '院士专家工作站', '博士后工作站', '博士后流动站', '中国专利奖', '研发人员多', '研发投入多', '研发能力强', '专利多', '有专利', '证书多', '有证书', '专利质量高'] },
				{ name: "特色标签", taglist: [], children: ['媒体热议', '名校背景', '名企背景', '上市公司供应商', '上市公司客户'] },
				{ name: "融资标签", taglist: [], children: ['刚获投', '连续获投', '融资窗口期', '刚上市', '融资金额大', '红杉资本中国', 'IDG资本', '腾讯投资', '知名投资机构', 'TOP10投资机构', 'TOP30投资机构', 'TOP50投资机构', '尚未获投', '种子轮', '天使轮', 'Pre-A轮', 'A轮', 'A+轮', 'Pre-B轮', 'B轮', 'B+轮', 'C轮', 'C+轮', 'D轮', 'D+轮', 'E轮', 'E+轮', 'F轮', 'G轮', 'H轮', 'Pre-IPO', '基石轮', '已上市', '新三板', '已退市', '战略投资', '不明确', '已被收购', '已合并'] },
				{ name: "投资实力", taglist: [], children: ['盈利能力强', '偿债能力强', '成长能力强', '现金流稳健', '近期有融资', '连续融资', '投资意愿强', '项目投资数量多', '近期有项目投资', '有项目投资', '连续项目投资', '股权投资数量多', '近期有股权投资', '有股权投资', '连续股权投资', '拿地面积大', '拿地数量多', '有拿地', '近期有拿地', '连续拿地'] },
			],
			tagarrlistSp: [
				{ name: 'a', children: ['项目投资数量多', '近期有项目投资', '有项目投资', '连续项目投资'], taglist: [] },
				{ name: 'b', children: ['股权投资数量多', '近期有股权投资', '有股权投资', '连续股权投资'], taglist: [] },
				{ name: 'c', children: ['拿地面积大', '拿地数量多', '有拿地', '近期有拿地', '连续拿地'], taglist: [] },
				{ name: 'd', children: ['盈利能力强', '偿债能力强', '成长能力强', '现金流稳健', '投资意愿强', '近期有融资', '连续融资'], taglist: [] },
			],
			tagtreelist: [], tagtreelist1: [{ taglist: [], }],
			randerdata: [{ date: "", 'mun': 0, 'money': 0, 'avg': 0, }],
			isradar: {},
			randerdata2: {},
			randerpagedata: {},
			ldtname: [],
			ldtvalue: [],
			issucss: false,
			addCRMid: 0,
			cusid: 0,
			iframeurl: '',
			iframestus: true, iframestus1: true,
			pagename: 0,//存页面跳转带来的pagename
			type: '',//存企业类型
			landInfo: {}, landAreaInfor: [],
			landEchartType: 1, projectEchartType: 1, landMapType: 1, projectMapType: 1,
			financeEchartType: 1,
			stocklist: {},//经营状况新增雷达图和链接
			mainBusiness: {},//经营状况新增主营构成
			customerArea: [],//客户区域
			supplierArea: [],//供应商区域
			projectList: [],//投资项目信息
			projectInfo: {},//投资项目基本信息
			projectArea: [],//投资项目区域
			technologyList: [],//科技型企业资质
			softwareList: [],//软件著作权
			financeList: [], financeTotalMoney: 0,//融资项目列表
			controllEntChart: {},//控制企业的区域分布数据
			investChart: {}, //对外投资的区域分布和时间投资分布
			strategy: [],//战略方向
			solvency: {}, sodataBtn: false,//偿债能力
			commerceList: [],//所属商会信息
			associationList: [],//所属协会信息
			localRelatedEnterprise: {
				controllEnterprise: [],
				customer: [],
				invest: [],
				shareholder: [],
				supplier: [],
				investOrg: [],
				commerce: [],
				association: [],
			},//联系方式-本地相关联企业
			relationship: [],//疑似关系 园区招商企业专有进阶数据
			changeLog: [],//变更记录 园区招商企业专有进阶数据
			scaleType: 1, //企业类型 1龙头企业 2创新企业 3优质企业
			shangshild: [{ name: '总体评分', avg: 65.55, median: 66.9 }, { name: '企业实力', avg: 57.37, median: 60.2 }, { name: '投资力度', avg: 55.45, median: 66.8 }, { name: '行业机会', avg: 75.66, median: 82 }, { name: '政策力度', avg: 87.23, median: 80 }, { name: '本省关联度', avg: 22.12, median: 20.4 },],//上市公司中位数
			longtould: [{ name: '总体评分', avg: 62.72, median: 63.1 }, { name: '企业实力', avg: 68.96, median: 74 }, { name: '投资力度', avg: 35.22, median: 40 }, { name: '行业机会', avg: 82.71, median: 87 }, { name: '政策力度', avg: 82.33, median: 80 }, { name: '本省关联度', avg: 12.99, median: 10.5 },],//龙头企业雷达图中位数
			chuangxinld: [{ name: '总体评分', avg: 57.02, median: 55.2 }, { name: '企业实力', avg: 51.96, median: 54 }, { name: '融资力度', avg: 29.39, median: 20 }, { name: '行业机会', avg: 84.15, median: 70 }, { name: '政策力度', avg: 83.81, median: 80 }, { name: '本省关联度', avg: 15.28, median: 12.5 },],//创新企业雷达图中位数
			youzhild: [{ name: '总体评分', avg: 43.96, median: 44.3 }, { name: '企业实力', avg: 35.01, median: 40 }, { name: '融资力度', avg: 10.27, median: 20 }, { name: '行业机会', avg: 76.58, median: 80 }, { name: '政策力度', avg: 77.45, median: 80 }, { name: '本省关联度', avg: 10.93, median: 10 },],//创新企业雷达图中位数
			medianldlist: [{ name: '', avg: 0, median: 0 }, { name: '', avg: 0, median: 0 }, { name: '', avg: 0, median: 0 }, { name: '', avg: 0, median: 0 }, { name: '', avg: 0, median: 0 }, { name: '', avg: 0, median: 0 },],
			ctitle: '',
			riskInformation: [],//企业风险标签信息
			enterprisedata1: {},
			unlock: false,//解锁下载报告弹框
			lock: false, //下载报告按钮是否上锁
			handdlebtn: true,
			sucuData: [], sucuDataPop: false,//供应商客户查看更多弹窗内容
			supplierInfornum: 0, customerInfornum: 0,//供应商客户公司列表原始个数
			scrollbtn: false, barHeight: 60,
			mergeList:{market:[],compete:[]},
			keyPersonalList:[],
			isShowFreeUserTips: false, //是否显示免费用户提示
			yearsLand: [],
			chartData: [],
			chartType: 'bar',
			productlist: [],
		}
	},
	components: {
		zhuyinggoucheng, localRelatedEnterprisea, investLinePie, enterpriseTaglist, enterpriseNotionGrade, patentLinePie,mergeListCharts,keyPersonal,
		vedioTips,
	},
	beforeCreate() { },
	created() {
		this.getuserinfor();
		this.enterpriseid = this.$route.query.id;
		this.parkid = this.$route.query.pid;
		// if (this.userdata.isFree ) {
		// 	this.$router.push({
		// 		path: '/enterprises-free?id=' + this.enterpriseid,
		// 	});
		// }
		this.bus.$emit('loading', true);
		// window.scrollTo(0,0); 
		var _this = this;

		if (this.$route.query.pagename) {
			this.pagename = this.$route.query.pagename;
		}
		this.ctitle = this.$route.query.ctitle;


		// console.log(this.userdata.token) 
		//公司数据
		this.getenterdetail(1);

	},
	mounted() {
		this.bus.$emit('loading', true);
		var _this = this;
		window.scrollTo(0, 0);
	},

	methods: {
		
		/**表头点击时弹出echarts图表弹框
		 * @description: 点击表头时弹出echarts图表弹框
		 * @param {string} dataType 数据类型（如researchlist）
		 * @param {string} dataName 数据名称（如num,numPercent,expend,expendPercent等）
		 * @param {string} chartType 图表类型（如bar,line等）
		 */
		handlerChart(dataType, dataName, chartType) {

			//先判断数据类型，在判断数据类型中要显示的图表类型
			if (dataType == 'researchlist') {
				const num = [], numPercent = [], expend = [], expendPercent = [];
				for (var i = 0; i < this.researchlist.length; i++) {
					num.push({ label: this.researchlist[i].year, value: this.researchlist[i].num });
					numPercent.push({ label: this.researchlist[i].year, value: this.researchlist[i].numPercent });
					expend.push({ label: this.researchlist[i].year, value: (this.researchlist[i].expend / 10000).toFixed(1) });
					expendPercent.push({ label: this.researchlist[i].year, value: this.researchlist[i].expendPercent });
				}
				// console.log(num, numPercent, expend, expendPercent);
				switch (dataName) {
					case 'num':
						this.chartData = this.deepClone(num);
						break;
					case 'numPercent':
						this.chartData = this.deepClone(numPercent);
						break;
					case 'expend':
						this.chartData = this.deepClone(expend);
						break;
					case 'expendPercent':
						this.chartData = this.deepClone(expendPercent);
						break;
				}
				 //chartData按年份从小到大排序
				 this.chartData.sort((a, b) => { return a.label - b.label; });
			}
			this.chartType = chartType;
			this.$refs['tableCharts'].open = true;
		},
					/**
			 * 深克隆对象方法
			 * @param {*} obj
			 * @returns 对象或者数组
			 */
			 deepClone (obj)  {
				// 如果是基本类型则直接返回
				if (typeof obj !== "object" || obj === null) {
					return obj;
				}
				// 根据obj的类型创建一个数组或者对象
				let newObj = Array.isArray(obj) ? [] : {};
				// 遍历obj，并赋值给newObj
				for (let key in obj) {
					newObj[key] = this.deepClone(obj[key]);
				}
				return newObj;
			},

		//拿地，专利等ai分析
		goAIChart(type,model) {
			if(!this.userdata.token){
				this.isShowFreeUserTips = true;
				return;
			}
			console.log(type,model);
			// 转换为字符串格式
			const landResult = this.yearsLand.map(item => `${item.name} ${item.value}`).join("\n");
			const researchResult = this.researchlist.map(item => `${item.year} ${item.num} ${item.numPercent} ${item.expend} ${item.expendPercent}`).join("\n");
			//存储到本地存储，每次点击覆盖前面的数据
			let aistitle = '';
			let aiChatData =  ``;
			switch (type) {
				case 1:
					aiChatData = this.getlandData(this.landlist);
					aistitle = '拿地数据和投资趋势分析';
					break;
				case 2:
					aiChatData = `历年专利总数 ${this.patentlist.length} \n ${this.getPatentData(this.patentlist)}`;
					aistitle = '专利数据和技术实力分析';
					break;
				case 3:
					aiChatData = `时间（年份）  研发人员数量（个） 研发人员占比（%）  研发支出合计（万元）  研发支出总额占营业收入比例（%）\n${researchResult}`;
					aistitle = '研发投入和创新能力分析';
					break;
			}
			let jsonData = {
				content: `表格名称 ${this.companyinfor.title}投资拿地数据统计表 \n公司名称 ${this.companyinfor.title} \n企业业务或产品 ${this.extendinfor.productName}\n`+aiChatData,
				title: this.companyinfor.title+aistitle,
			};
			console.log(jsonData);
			localStorage.setItem('aiChatData', JSON.stringify(jsonData));
			// console.log('test',localStorage.getItem('aiChatData'));
			this.routerblank('/aiChat?id='+this.enterpriseid+'&model='+model+'&type='+type);
		},
		//提取拿地数据转换为ai页面要传给后台的数据字符串格式
		getlandData(data) {
			// 按年份统计拿地数量
			const landCountByYear = data.reduce((acc, item) => {
				const year = item.datetime; // 提取年份
				const size = item.size; // 拿地数量（亩）

				if (!acc[year]) {
					acc[year] = 0;
				}
				acc[year] += size; // 累加当年的拿地数量
				return acc;
			}, {});

			// 转换为指定格式字符串
			const result = Object.entries(landCountByYear)
				.map(([year, size]) => `${year} ${size.toFixed(1)}`)
				.join("\n");

			// 添加表头
			const formattedResult = `时间（年份） 当年的拿地数量（亩）\n${result}`;
			return formattedResult;
			console.log(formattedResult);
		},
		//提取专利数据转换为ai页面要传给后台的数据字符串格式
		getPatentData(data) {
			// 按专利类型统计数量
			const patentTypeCount = data.reduce((acc, item) => {
				const type = item.type; // 提取专利类型
				acc[type] = (acc[type] || 0) + 1; // 累加数量
				return acc;
			}, {});

			// 转换为指定格式字符串
			const result = Object.entries(patentTypeCount)
				.map(([type, count]) => `${type}: ${count}`)
				.join("\n");

			return result;
		},
		//产业数据（竞争格局和市场规模）
		getMergeList(){
			let ajaxUrl = this.$api.common.market.mergeList() + '?stockCode='+ this.companyinfor.stockCode+'&num=6';
			this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then( (res) => {
				console.log('竞争格局',res);
				if(res.data.success){
					this.mergeList = res.data.data;
				}
			}).catch(function (error) {
				// 请求失败处理
			});
			 
		},
		//增加移除企业对比
		togEnterpriseComparison(id) {
			var ajaxurl = id == 0 ? this.$api.cyl.enterpriseComparison.addEnterprise() : this.$api.cyl.enterpriseComparison.deleteEnterprise();
			let ajaxdata = { stockCode: this.enterpriseid }, that = this;
			console.log(id, ajaxurl);
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: ajaxdata,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log('toggleRelationEnterprise',res);
					var msgtype = res.success ? 'success' : 'warning';
					var msgtext = id == 0 ? '添加成功，可前往企业对比页面查看' : '移除企业对比';
					msgtext = res.success ? msgtext : res.msg;
					if (res.success) {
						if (id == 0) {
							that.companyinfor.enterpriseComparisonId = res.data;
						} else {
							that.companyinfor.enterpriseComparisonId = 0;
						}
					}
					that.$message({
						type: msgtype,
						message: msgtext,
					});
				}
			})
		},
		extractProducts(productListStr) {
            let product = productListStr.match(/[^：：]+$/gm);
            return product;
        },
		//投资动态跳转到投资项目库页面
		openProjectLink(url) {
			if (url && url != '') {
				window.open(url); //研究报告库外部跳转
			}
		},
		//融资项目折线图切换
		financeChart(type, title) {
			this.financeEchartType = type;
			var unit = "个";
			if (type == 1 || type == 3) {
				unit = '亿元';
			}
			this.linechartfun('rzxm-line', this.financeList, 'finance', type, title, unit);
		},
		//拿地信息图表信息的切换
		landEchart(type, title) {
			this.landEchartType = type;
			var unit = "块";
			if (type == 1 || type == 3) {
				unit = '亩';
			}
			if (type > 2) {
				this.landpiefun('nadixinxi-pie', [], 'land', type, title, unit); //拿地信息饼图 城市拿地面积大小排序  
			} else {
				this.landpiefun('nadixinxi-pie', this.landInfo.cityList, 'land', type, title, unit); //拿地信息饼图 城市拿地面积大小排序 
			}
			this.linechartfun('nadixinxi-line', this.landlist, 'land', type, title, unit);
		},
		projectEchart(type, title) {
			this.projectEchartType = type;
			var unit = "个";
			if (type == 1 || type == 3) {
				unit = '亿元';
			}
			if (type > 2) {
				this.landpiefun('touzixiangmu-pie', [], 'project', type, title, unit); //拿地信息饼图 城市拿地面积大小排序  
			} else {
				this.landpiefun('touzixiangmu-pie', this.projectArea, 'project', type, title, unit); //拿地信息饼图 城市拿地面积大小排序 
			}
			// this.landpiefun('touzixiangmu-pie',this.projectArea,'project',type,title,unit); //投资项目饼图
			this.linechartfun('touzixiangmu-line', this.projectList, 'project', type, title, unit); //投资项目折线图 
		},
		landMapEchart(type, title) {
			this.chianmapFun('landMapInfor', this.landInfo.cityList, 'land', type, title);;//拿地信息区域地图   
			this.landMapType = type;
		},
		projectMapEchart(type, title) {
			this.chianmapFun('projectMapInfor', this.projectArea, 'project', type, title);//投资信息信息区域地图  
			this.projectMapType = type;
		},
		//判断企业网址是否符合标准 长度大于4并且要有http
		getEnterpriseWebsite(str) {
			// console.log('str',str)
			if (str.length > 3) {
				if (str.indexOf('http') < 0) {
					str = 'http://' + str;
				}
			}
			this.enterpriseWebsite = str;
		},
		//页面最顶部的解锁动态
		pagelockfun() {
			if (this.enterprisedata1.unlockRemainder > 0) {
				this.unlock = true;
			} else {
				this.bus.$emit('tipspop', { lock: true, type: "permissionNum" });
			}
		},
		//加入企业投资动态id
		userenterpriseToggle() {
			//console.log(this.userEnterpriseId);
			var _this = this, datad = {}, ajaxurl = '', msgtype = "", msgtext = "";
			var id = this.userEnterpriseId;
			if (id > 0) {
				datad = { id: id }; ajaxurl = this.$api.cyl.userenterprise.remove();
				// var res={data:{id:0}};
			} else {
				datad = { stockCode: this.enterpriseid }; ajaxurl = this.$api.cyl.userenterprise.add();
				// var res={data:{id:8}};
			}
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: datad,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					if (res.success) {
						if (id == 0) {
							_this.userEnterpriseId = res.data.id;
							msgtext = "已加入企业投资动态";
						} else {
							_this.userEnterpriseId = 0;
							msgtext = "已移除企业投资动态";
						}
						msgtype = "success";
					} else {
						msgtype = "error";
						msgtext = res.msg;
					}
					_this.$message({
						type: msgtype,
						message: msgtext,
					});
					// if(res.success){ 
					// //		console.log(res);
					// 		if(id>0){ 
					// 			 _this.userEnterpriseId=0;
					// 		}else{ 
					// 			_this.userEnterpriseId=res.data.id; 
					// 		}  
					// } 
				}
			})
		},
		//试用账号解锁下载报告
		unlockfun(ele) {
			var _this = this;
			// console.log('解锁下载报告');  
			// _this.getenterdetail(2);
			// 		_this.unlock= false;
			// 		_this.lock = true; 
			// console.log(_this.unlock,_this.lock);
			this.lockopen = true;
			this.lockbtnfont = "解锁中";
			this.$axios.get(this.$api.cyl.enterprise.unlock() + '?stockCode=' + this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				_this.lockopen = false;
				_this.lockbtnfont = "解锁成功";
				// console.log(res); 
				if (res.data.success) {
					_this.getenterdetail(2);

					_this.unlock = false;
					_this.lock = true;

				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//企业网址跳转
		geturl(url) { window.open(url); },
		getGrade(indexd) {
			if (indexd < 4) { return "A" }
			if (indexd > 3 && indexd < 7) { return "B" }
			if (indexd > 6) { return "C" }
		},
		download() {  //下载企业报告
			this.downloadurl = this.$api.download.enterprise.whole() + '?c=' + this.enterpriseid + '&t=' + btoa(this.userdata.token) + '&type=' + this.curWebsite.downloadRptType;
			console.log('下载报告地址链接', this.downloadurl);
			this.iframeurl = this.downloadurl;
			window.open(this.downloadurl, "_blank",);
			this.iframestus = false;
			setTimeout(() => {
				this.iframestus = true;
			}, 60000)
		},
		downloadFinanceReport() {  //经营状况下载企业报告 
			if (!this.enterprisedata1.unlock && !this.lock) {
				this.pagelockfun();
				return;
			}
			var downloadurld = this.$api.download.enterprise.finance() + '?c=' + this.enterpriseid + '&t=' + btoa(this.userdata.token);
			// alert(downloadurld)
			// this.iframeurl =  this.downloadurl; 
			window.open(downloadurld, "_blank",);
			this.iframestus1 = false;
			setTimeout(() => {
				this.iframestus1 = true;
			}, 60000)
		},
		swapArr(arr, index1, index2) { //调换数组元素位置
			arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			return arr
		},
		//保留两位小数
		getnum(num) {
			num = num + '';
			var figure = '';
			if (num.indexOf('.') != -1) {  //小数则返回前两位,整数则返回原数据，
				figure = num.substring(0, num.indexOf('.') + 2);
			} else if (num.indexOf('.0') != -1) {
				figure = num
			}
			else {
				figure = num
			}
			return figure;

		},
		getranderdata(type, code) {
			var _this = this;
			this.zsldnav = code
			if (type == 0) {
				var ajaxurl = this.$api.cyl.GovInvestAlg.detail() + "?stockCode=" + this.enterpriseid;
			} else {
				var ajaxurl = this.$api.cyl.GovInvestAlg.detail() + "?stockCode=" + this.enterpriseid + "&notionCode=" + _this.zsldnav;
			}
			this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log("雷达图数据",res.data,ajaxurl);
				_this.issucss = res.data.success;
				if (res.data.success) {
					if (type == 0) {
						_this.zsldnav = res.data.data.notionList[0].code;
					}
					_this.randerdata2 = res.data.data;
					_this.randerdata = res.data.data.provinceRelated;
					_this.randerpagedata = res.data.data;
					_this.ldtname = res.data.list;
					_this.ldtname = _this.swapArr(_this.ldtname, 4, 5)
					_this.ldtname[0].text = '总体评分';

					var newdata = res.data.list.filter((list) => {
						return list.text != '本省关联度' && list.text != '总体评分';
					});

					// _this.convert(res.data.data.project);
					setTimeout(() => {
						_this.holdradarFun('enterprise_zsldtchart', newdata);  //$nextTick没用就用了定时器，不用的话图不能实时获取盒子高度
					}, 500)
				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		convert(source) {  //招商雷达项目投资信息表格数据转换
			var _this = this;
			var dict = {};
			["money", "num", "avg"].forEach(key => {
				source[key].forEach(item => {
					var month = item.month,
						data = item.data;
					if (!dict[month]) {
						dict[month] = {};
						dict[month].date = month;
					}
					dict[month][key] = data;
				})
			});
			var result = [];
			for (var key in dict) {
				result.push(dict[key]);
			}
			_this.randerdata = result;
			// console.log('result',result);
			return result;

		},
		sortKey(array, key) {//正序从大到小
			return array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				return ((x > y) ? -1 : (x < y) ? 1 : 0)
			})
		},
		sortKey2(array, key) {    				//正序从小到大
			return array.sort(function (a, b) {
				var x = a[key];
				var y = b[key];
				return ((x < y) ? -1 : (x > y) ? 1 : 0)
			})
		},
		percnetfun(data) {
			var sumdata = 0, prosum = 0, otherarea = {}, databox = [], otherbtn = false;
			for (var i = 0; i < data.length; i++) {
				sumdata += data[i].value;
				// prosum += data[i].provinceCount;
				// 目标的个数÷总数×100%
			}
			for (var n = 0; n < data.length; n++) {
				// console.log(data[n]);
				data[n].percent = data[n].value / sumdata * 100;
			}
			return data;
		},
		//获取详情页信息
		getenterdetail(step) {
			var _this = this;
			var ajaxurl = this.$api.cyl.enterprise.detail();
			if (step == 2) {
				ajaxurl = this.$api.cyl.enterprise.detail2()
			}
			this.$axios.get(ajaxurl + "?stockCode=" + this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log(res.data)
				console.log('第' + step + '部分信息', res.data);
				if (res.data.success) {
					if (step == 1) {
						_this.topDownloadBtn = _this.userdata.operatList.xzbg.btn && res.data.data.baseinfo.collectType != 16 && !_this.parkid;//园区大脑全部企业列表联合  外资企业隐藏下载报告按钮
						if (res.data.data.baseinfo.collectType != 16) {
							_this.getranderdata(0);
							_this.isradar = res.data.data.radar;
						}
						_this.enterprisedata1 = res.data.data;
						if (_this.enterprisedata1.unlock) {
							// _this.showzhuanlinum=5;
							// _this.showsuppliernum=5;
							// _this.showcustomernum =5;
						}
						// console.log('12321',_this.enterprisedata1);
						document.title = res.data.data.baseinfo.title;
						_this.getEnterpriseWebsite(res.data.data.baseinfo.website);
						_this.zhaoshangjihui = res.data.data.node;
						_this.leaderpagetype = res.data.data.baseinfo.scaleType * 1 + 1;
						_this.guidepagefun(res.data.data.baseinfo.scaleType);
						_this.companyinfor = res.data.data.baseinfo;//基础信息
						if(_this.companyinfor.notionCode && _this.companyinfor.notionCode != ''){
							_this.getMergeList();
						}   
						_this.scaleType = res.data.data.baseinfo.scaleType; //企业类型
						_this.userEnterpriseId = res.data.data.userEnterpriseId;
						_this.extendinfor = res.data.data.extend;//产品名称和类型
						_this.extendinfor.siteListArry = _this.taglistfun(_this.extendinfor.siteText, _this.extendinfor.site);
						_this.productlist = _this.extractProducts(_this.extendinfor.coreProduct);
						_this.riskInformation = _this.taglistfun(res.data.data.extend.riskTag, res.data.data.extend.riskTagCode,);//企业风险信息标签
						_this.companyinfor.taglist = _this.taglistfun(_this.companyinfor.tag, _this.companyinfor.tagCode);
						_this.gettagchainlist(_this.companyinfor.tag, _this.companyinfor.tagCode);
						_this.companyinfor.notionlist = _this.taglistfun(_this.companyinfor.notion, _this.companyinfor.notionCode, 'notionsort');
						_this.strategy = res.data.data.strategy || [];
						var keyword = _this.strategy.keywords.split('，');
						var description = _this.strategy.description.split('。');
						_this.strategy.keywords = keyword;
						_this.strategy.description = description;
						// console.log(_this.strategy.keywords,_this.strategy.description);
						_this.isExist();

						_this.getParkEnDetail(_this.parkid);
						// if(_this.ctitle == undefined){
						setTimeout(function () {
							_this.bus.$emit('loading', false);
						}, 2600);
						if (_this.userdata.groupType != 2) {
							_this.getenterdetail(2);
						}
						// }
						// //测试试用账户解锁试用
						// _this.enterprisedata1.unlock=false;
						// _this.enterprisedata1.unlockRemainder=0; 
					} else if (step == 2) {
						_this.secondData = res.data.data;
						_this.localRelatedEnterprise = res.data.data.localRelatedEnterprise;//联系方式-本地相关联企业
						// console.log('sec',_this.secondData);
						// _this.riskInfoData={executedPerson:[],judgmentDoc:[],breakPromise:[],judicialCase:[],limitExpense:[]};
						_this.riskinfobtn = res.data.data.executedPerson.length > 0 || res.data.data.judgmentDoc.length > 0 || res.data.data.breakPromise.length > 0 || res.data.data.judicialCase.length > 0 || res.data.data.limitExpense.length > 0;
						_this.eqpledgeBtn = res.data.data.stockPledge.length > 0 || res.data.data.pledgeShareholder.length > 0 || res.data.data.pledgeDetail.length > 0;
						let newslist = _this.contactNewsList(res.data.data.newsList, res.data.data.ocnNews);//拼接信息 
						_this.newslist = _this.sortKey(newslist, 'publishTime'); //按时间从近到远排序
						_this.commerceList = res.data.data.commerceList;//所属商会信息
						_this.associationList = res.data.data.associationList;//所属协会信息
						_this.projectList = res.data.data.projectList; //投资项目  
						_this.technologyList = res.data.data.technology ? res.data.data.technology : [];//科技型企业资质
						_this.technologyList = _this.sortKey(_this.technologyList, 'publishDate'); //企业资质排序
						_this.softwareList = res.data.data.software ? res.data.data.software : [];//软件著作权
						_this.financeList = res.data.data.financeList ? res.data.data.financeList : [];//融资项目
						for (var i = 0; i < _this.financeList.length; i++) {
							_this.financeTotalMoney += _this.financeList[i].money;
						}
						_this.solvency = res.data.data.solvency ? res.data.data.solvency : _this.solvency;
						_this.sodataBtn = _this.curWebsite.type == 4 && res.data.data.solvency != null;
						// _this.financeTotalMoney=(_this.financeTotalMoney/10000).toFixed(2);
						if (_this.projectList.length > 0) {
							_this.projectList = _this.sortKey(_this.projectList, 'date'); //按时间从近到远排序
						}
						if (_this.scaleType == 1 && _this.projectList.length <= 0) { //龙头企业招商算法中位数 
							_this.medianldlist = _this.longtould;
						} else if (_this.scaleType == 2) { //创新企业招商算法中位数
							// console.log('创新企业');
							_this.medianldlist = _this.chuangxinld;
						} else if (_this.scaleType == 3) { //优质企业招商算法中位数 
							_this.medianldlist = _this.youzhild;
						} else if (_this.projectList.length > 0) { //上市公司招商算法中位数 
							_this.medianldlist = _this.shangshild;
						}
						_this.mainBusiness = res.data.data.mainBusiness;
						// console.log(res.data.data);
						_this.certificatelist = res.data.data.certificate;//证书信息
						_this.investlist = res.data.data.invest;//对外投资信息 
						_this.investChart = res.data.data.investChart;
						if (_this.investlist.length > 0) {
							_this.investlist = _this.sortKey(_this.investlist, 'createTime');
						}
						_this.financingRound = res.data.data.financingRound;//融资信息
						_this.financing = res.data.data.financing.length > 0 ? res.data.data.financing : [{ summary: "", team: "", valuation: "", projectName: "", number: "", business: "", amount: "" }];//融资信息
						_this.landInfo = res.data.data.landInfo || [];
						_this.patentlist = res.data.data.patent;//发明专利信息
						_this.shareholderlist = res.data.data.shareholder;//股东信息 
						_this.scoreDetail = res.data.data.scoreDetail;//得分详细
						_this.controllEnterprise = res.data.data.controllEnterprise;//控制企业
						// _this.controllEnterprisefun(res.data.data.controllEnterprise);
						_this.controllEntChart = res.data.data.controllEntChart;
						_this.realController = res.data.data.realController;//实际控制人 
						_this.customerInfornum = res.data.data.customer.length;
						_this.supplierInfornum = res.data.data.supplier.length;
						_this.supplier = _this.suplierCustoFun('供应商', res.data.data.supplier);//供应商 
						_this.customer = _this.suplierCustoFun('客户', res.data.data.customer);//客户
						_this.landlist = res.data.data.land || [];//拿地信息
						if (_this.landlist.length > 0) {
							_this.landlist = _this.sortKey(_this.landlist, 'time');
						}
						// console.log('项目拿地分布信息',)
						_this.projectInfo = res.data.data.projectInfo; //投资项目基本信息
						_this.projectArea = res.data.data.projectArea; //投资项目分布区域
						var softwareList = _this.getDateData(_this.softwareList, 'regDate');
						var certificatelist = _this.getDateData(_this.certificatelist, 'startDate');
						// var softwareList=getDateData(this.softwareList,'regDate');
						setTimeout(() => {
							_this.financeChart(1, '历年融资金额');
							_this.landEchart(1, '拿地面积');
							_this.projectEchart(1, '项目金额');
							_this.landMapEchart(1, '拿地面积区域分布');
							_this.projectMapEchart(1, '项目金额区域分布');
							_this.linechartfun('zzq-line-echart', softwareList, 'zzq', 1, '登记数量', '条'); //投资项目折线图 
							_this.linechartfun('zzzs-line-echart', certificatelist, 'zzzs', 1, '发证数量', '个'); //投资项目折线图 
						}, 1000)
						_this.researchlist = res.data.data.research || [];//研发信息 
						if (_this.shareholderlist.length > 0) {
							setTimeout(() => {
								var tableheight = document.getElementsByClassName('gdxx-h');
								var sharholderh = document.getElementById('detail_sharholder');
								sharholderh.style.height = tableheight[0].clientHeight + 'px';
								_this.shareholderPie('detail_sharholder', _this.shareholderlist); //股东信息柱形图
							}, 500)
						}
						_this.keyPersonalList = res.data.data.keyPersonal || [];//主要人员
						_this.yingyeshouru = res.data.data.revenue;//营业收入 
						// console.log(document.body.offsetWidth*0.8728*0.95*0.48)
						_this.stocklist = res.data.data.stock != null ? res.data.data.stock : {};
						if (_this.stocklist.html) {
							_this.stocklist.html = res.data.data.stock.html.replace(/，行业排名\d+\/\d+/g, "");
						}
						if (res.data.data.stock != null) {
							_this.jyzkRadar('jyzk_radar', _this.stocklist.radar);
						}
						// console.log(_this.stocklist)
						if (_this.yingyeshouru.data.length > 0) {
							_this.jinliruBar('businessincome', _this.yingyeshouru);
							// console.log('看看营业收入的数据格式',_this.yingyeshouru)
						}
						_this.netprofitlist = res.data.data.profit;//净利润
						if (_this.netprofitlist.data.length > 0) {
							_this.jinliruBar('netprofit', _this.netprofitlist);
						}
						_this.supplierArea = _this.percnetfun(res.data.data.supplierArea) || [];//供应商区域
						_this.customerArea = _this.percnetfun(res.data.data.customerArea) || []; //客户区域  
						_this.sortKey(_this.customerArea, "value"); //从大到小排序
						_this.sortKey(_this.supplierArea, "value");
						setTimeout(() => {
							_this.qiantaopiefun('gys_pie', _this.supplierArea); //供应商双层饼图
							_this.qiantaopiefun('kh_pie', _this.customerArea); //客户双层饼图
							// _this.qiantaopiefun('kh_pie', _this.khdata); //客户双层饼图
							// _this.funa(); 
							if (_this.ctitle != undefined && _this.ctitle.indexOf('gk') > -1) {
								document.getElementById("supplier").scrollIntoView({ behavior: 'smooth' });
								// var oftop4=document.getElementById('supplier').offsetTop-110;
								// alert(oftop4)
								// window.scrollTo(0, oftop4);
							} else if (_this.ctitle != undefined && document.getElementById(_this.ctitle)) {
								document.getElementById(_this.ctitle).scrollIntoView({ behavior: 'smooth' });
							}

							window.addEventListener("scroll", _this.handleScroll, true);
							_this.barHeight = document.getElementsByClassName('ende_floorlist')[0].offsetHeight;
							// console.log(_this.barHeight)
						}, 1000)
						_this.scrollbtn = true;
						// _this.secondFlag=true;

					}
				}else {
					// _this.isShowFreeUserTips = true;  //避免第二部分信息没拿到导致弹出提示
					_this.bus.$emit('loading', false);
				}
			}).catch(function (error) { });
		},
		//提取年份数据信息
		getDateData(data, typename) {
			// alert(8754)
			var data1 = [], data2 = [];
			data.forEach((list, i) => {
				var datayear = list[typename].split('-')[0];
				if (data1.indexOf(datayear) < 0) {
					data1.push(datayear);
					data2.push({ name: datayear, value: 0 });
				}
			});
			data.forEach(list => {
				var datayear = list[typename].split('-')[0];
				data2.forEach(item => {
					if (datayear == item.name) {
						item.value++;
					}
				})
			});
			return data2;
		},
		//获取园区企业详情页进阶数据
		getParkEnDetail(pid) {
			if (!pid) { return; }
			var _this = this;
			var ajaxurl = this.$api.park.enterprise.detail2();
			this.$axios.get(ajaxurl + "?stockCode=" + pid, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				// console.log(res.data)
				console.log('获取园区企业详情页进阶数据', res.data.data);
				if (res.data.success) {
					_this.relationship = res.data.data.relationship ? res.data.data.relationship : [];//疑似关系
					_this.changeLog = res.data.data.changeLog ? res.data.data.changeLog : [];//变迁记录 
				} else {
					_this.tokenfailed(res.data.msg);
				}
			}).catch(function (error) { });
		},
		//拼接资讯列表
		contactNewsList(newslist, ocnNews) {
			newslist = newslist ? newslist : [];
			ocnNews = ocnNews ? ocnNews : [];
			var newsdata = [];
			for (var i = 0; i < newslist.length; i++) {
				newslist[i].url = "/informationdetail";
			}
			for (var i = 0; i < ocnNews.length; i++) {
				ocnNews[i].url = "/news";
			}
			newsdata = newslist.concat(ocnNews);
			return newsdata;
		},
		gettagchainlist(tagname, tagcode) {
			// console.log(tagname,tagcode);
			var localchain = this.tagarrylist;
			var localJstag = this.tagarrlistSp;
			var reschain = [], reschain1 = [];
			var ddtaglist = this.taglistfun(tagname, tagcode);
			for (var i = 0; i < ddtaglist.length; i++) {
				let arrts = ddtaglist[i], arrtsname = ddtaglist[i].name;
				for (var d = 0; d < localJstag.length; d++) {
					for (var s = 0; s < localJstag[d].children.length; s++) {
						if (localJstag[d].children[s] == arrtsname) {
							localJstag[d].taglist.push(arrts);
						}
					}
				}
			}
			for (var i = 0; i < ddtaglist.length; i++) {
				let arrts = ddtaglist[i], arrtsname = ddtaglist[i].name;
				for (var d = 0; d < localchain.length; d++) {
					for (var s = 0; s < localchain[d].children.length; s++) {
						if (localchain[d].children[s] == arrtsname) {
							localchain[d].taglist.push(arrts);
						}
					}
				}
			}
			this.tagtreelist = localchain;
			this.tagtreelist1 = localJstag;
		},
		//供应商客户信息处理
		suplierCustoFun(name, data) {
			// var data1=data;
			for (var i = 0; i < data.length; i++) {
				data[i].children = [];
				data[i].isrepeat = false;
			}
			for (var i = 0; i < data.length; i++) {
				var dataname = data[i].name;
				for (var d = i + 1; d < data.length; d++) {
					var dataname1 = data[d].name;
					if (dataname == dataname1 && !data[i].isrepeat) {
						// console.log(i,d,dataname,dataname1,data[d].stockCode);
						// console.log(dataname1,dataname == dataname1,data[i].isrepeat)
						if (data[i].stockCode == '') {
							data[i].stockCode = data[d].stockCode;
						}
						data[i].children.push(data[d]);
						data[d].isrepeat = true;
						// data[i].isrepeat=true;
					}
				}
			}
			var dds = data.filter(list => {
				return !list.isrepeat;
			})
			// console.log('suplierCustoFuna'+name,dds); 
			return dds;
		},
		//供应商客户信息查看更多
		supplycustomerMore(data) {
			this.sucuData = data;
			this.sucuDataPop = true;
		},
		contorlpatent(type, islock) {
			// console.log(islock);
			// console.log(this.patentlist.length,this.showzhuanlinum);
			if (type == 'zl') {
				if (this.showzhuanlinum < this.patentlist.length) {
					this.showzhuanlibtn++;
				} else {
					this.showzhuanlibtn = 1;
				}
				// if(islock){
				// 	this.showzhuanlinum=this.showzhuanlibtn*20;
				// }else{
				this.showzhuanlinum = this.showzhuanlibtn * 100;
				// }
			} else if (type == 'sp') {
				if (this.showsuppliernum < this.supplierInfornum) {
					this.showsupplierbtn++;
				} else {
					this.showsupplierbtn = 1;
				}
				this.showsuppliernum = this.showsupplierbtn * 100;
			} else if (type == "cu") {
				if (this.showcustomernum < this.customerInfornum) {
					this.showcustomerbtn++;
				} else {
					this.showcustomerbtn = 1;
				}
				this.showcustomernum = this.showcustomerbtn * 100;
			}
		},
		detailrouterto(path, id) {
			if (id == 0 || id == "") { return; }
			let routeUrl = this.$router.resolve({
				path: path, query: { id: id }
			});
			window.open(routeUrl.href, '_blank');
		},
		getuserinfor() {
			let dataddd = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
			if (typeof (dataddd) == 'object') {
				this.userdata = dataddd;
			} else {
				this.userdata = JSON.parse(dataddd);
			};
			// console.log('不可复制',!this.userdata.copy)
			if (!this.userdata.copy) {
				this.$nextTick(() => {
					// 禁用右键
					document.oncontextmenu = new Function("event.returnValue=false");
					// 禁用选择
					document.onselectstart = new Function("event.returnValue=false");
				});
			}
		},
		//主营业务字太多
		editfontnum(type) {
			var defaultnum = this.defaultmainnum;
			if (type == "main") {
				this.mainfontnum = this.mainfontnum == defaultnum ? this.companyinfor.mainBusiness.length : defaultnum;
			} else if (type == "busin") {
				this.businfontnum = this.businfontnum == defaultnum ? this.companyinfor.businessScope.length : defaultnum;
			} else if (type == "sum") {
				this.sumfontnum = this.sumfontnum == defaultnum ? this.companyinfor.summary.length : defaultnum;
			} else if (type == 'team') {

				this.teamfontnum = this.teamfontnum == defaultnum ? this.financing[0].team.length : defaultnum;
				// console.log(this.teamfontnum,defaultnum)
			}
		},
		//添加删除收藏
		collectFun() {
			// console.log(this.companyinfor.collectId,this.companyinfor);
			this.listToggleCollect(this.companyinfor)
		},

		//查询是否存在CRM库
		isExist() {
			var _this = this;
			this.$axios.get(this.$api.crm.enterprise.isExist() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				// console.log("是否存在企业库",res);  
				if (res.data.success) {
					if (res.data.data == 'true') {
						_this.addCRMid = res.data.extend.id;
					}
					// console.log(_this.addCRMid);
					// _this.companyinfor.addCRMid=1;
				}

			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//从企业库添加或删除CRM库
		addtoCRM() {
			var _this = this;
			if (_this.addCRMid == 0) {
				this.$axios.get(this.$api.crm.enterprise.addtoCRM() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
					// console.log("添加到CRM库",res);   
					if (res.data.success) {
						_this.addCRMid = res.data.data.id;
						// console.log('客户id',_this.addCRMid); 
						_this.$message({ type: 'success', message: "已加入项目管理" })
					}

				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			} else {
				console.log('移除', _this.addCRMid)
				$.ajax({
					type: "POST",
					url: this.$api.crm.customer.delete(),
					data: { id: _this.addCRMid },
					headers: { AuthToken: this.userdata.token },
					success: function (res) {
						console.log(res)
						// console.log('cusid',_this.addCRMid);
						// console.log(res); 
						if (res.success) {
							_this.addCRMid = 0;
							_this.$message({ type: 'success', message: "已移出项目管理" })
						}
					}
				})
			}
		},
		//测试title的问题
		testFloorTitle() {
			console.log(document.getElementsByClassName('d-floortitle').length, document.getElementsByClassName('floorlistLi').length)
			for (var i = 0; i < document.getElementsByClassName('d-floortitle').length; i++) {
				console.log(document.getElementsByClassName('d-floortitle')[i], document.getElementsByClassName('floorlistLi')[i]);
			}
		},
		handleScroll: function (e) {
			if (!this.scrollbtn) { return };
			var locahref = window.location.href.toLowerCase();
			var isEnterpage = locahref.indexOf('enterprises') > 0;
			if (!isEnterpage) {
				return;
			}
			// ende_floorlistfixed

			var enflolength = document.getElementsByClassName('ende_floorlistfixed').length;
			// console.log('enflolength1',enflolength)
			if (enflolength < 1) { return; }
			var sctop = document.documentElement.scrollTop;
			var bartop = document.getElementsByClassName('ende_floorlist')[0].offsetTop;
			// console.log(sctop,bartop);
			if (sctop < bartop) {
				document.getElementsByClassName('ende_floorlistfixed')[0].className = "ende_floorlistfixed";
			} else {
				document.getElementsByClassName('ende_floorlistfixed')[0].className = "ende_floorlistfixed fixedbox";
				var lengtsd = document.getElementsByClassName('floorlistLi').length;
				// console.log(lengtsd,document.getElementsByClassName('d-floortitle').length )
				for (var i = 0; i < lengtsd; i++) {
					// console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('d-floortitle')[i+1])
					var top1 = document.getElementsByClassName('d-floortitle')[i].offsetTop - this.barHeight;
					// console.log(top1, sctop,i)
					if (i < lengtsd - 1) {
						var top2 = document.getElementsByClassName('d-floortitle')[i + 1].offsetTop - this.barHeight;
						
						if (top1 > 0 && top2 > 0 && sctop > top1 && sctop < top2) {
							this.floorscroll(i, 'scroll');
						}
					} else if (i == lengtsd - 1) {
						if (top1 > 0 && sctop > top1) {
							this.floorscroll(i, 'scroll');
						}
					}
				};
			}
		},
		floorscroll(indexs, type) {
			// console.log(indexs,type);
			var oftop = document.getElementsByClassName('d-floortitle')[indexs].offsetTop - this.barHeight + 6;
			var lengtsd = document.getElementsByClassName('floorlistLi').length;
			// console.log('floorsrcoll',lengtsd);
			for (var i = 0; i < lengtsd; i++) {
				var classNameaf = "floorlistLi";
				if (i == indexs) {
					classNameaf = "floorlistLi current";
				}
				document.getElementsByClassName('floorlistLi')[i].className = classNameaf;
			}
			if (type != 'scroll') {
				// console.log('非',type,oftop);
				window.scrollTo(0, oftop);
			}
			if (type == 'test') {
				this.testFloorTitle();
				// console.log(this.riskinfobtn, this.eqpledgeBtn)
			}
		},
		guidepagefun(companytype) {
			var usertype = this.userdata.userType, headerdata = [];
			if (companytype == 1) {
				this.guidelink = "/leading-enterprises";
				headerdata = this.leadingheader;
			} else if (companytype == 2) {
				if (usertype == 2 || usertype == 3) {
					this.guidelink = "/investment-project";
				} else if (usertype == 1) {
					this.guidelink = "/innovative-enterprises";
				}
				headerdata = this.innovativeheader;
			}
			for (var i = 0; i < headerdata.length; i++) {
				let datas = headerdata[i];
				if (datas.type == usertype) {
					this.guidepage = datas.name;
					this.curindex = datas.curindex;
					return;
				}
			}
		},
		controllEnterprisefun(data) {
			var companyname = this.companyinfor.title;
			for (var i = 0; i < data.length; i++) {
				let tds = data[i].investChain;
				data[i].investChainhtml = tds.split('路径');
				var proportionnum = data[i].proportion;
				if (proportionnum.indexOf('%') < 0) {
					data[i].proportion = data[i].proportion * 100 + '%';
				}
				for (var d = 0; d < data[i].investChainhtml.length; d++) {
					if (data[i].investChainhtml[d] != "") {
						let ddsttss = data[i].investChainhtml[d];
						ddsttss = "<b>路径" + ddsttss;
						var indst = ddsttss.indexOf('%）') + 2;
						data[i].investChainhtml[d] = ddsttss.slice(0, indst) + '</b>' + ddsttss.slice(indst);
					}
				}
			}
			// console.log('controllEnterprisefun控制企业',data[7],data[8])
			this.controllEnterprise = data;
		},

		//供应商客户嵌套饼图

		qiantaopiefun(el, data) {
			var serdata1 = [], serdata2 = [];
			for (var i = 0; i < data.length; i++) {
				serdata1.push({ name: data[i].name, value: data[i].value });
				// serdata2.push({name:data[i].province,value:data[i].provinceCount});
			}
			// serdata2 = this.unique(serdata2);
			var chart = echarts.init(document.getElementById(el));
			var option = {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				// legend: {
				//   data: [
				//     'Direct',
				//     'Marketing',
				//     'Search Engine',
				//     'Email',
				//     'Union Ads',
				//     'Video Ads',
				//     'Baidu',
				//     'Google',
				//     'Bing',
				//     'Others'
				//   ]
				// },
				series: [
					// {
					//   name: '省份',
					//   type: 'pie', 
					//   radius: [0, '40%'],
					//   label: {
					// 				color :'#fff',
					//     position: 'inner',
					//     fontSize: 14,
					// 				formatter: function(params) {
					// 					let rethtml = params.name+'\n'+params.value;
					// 					return rethtml; 
					// 				}
					//   },
					//   labelLine: {
					//     show: false
					//   },
					//   data: serdata2,
					// },
					{
						name: '城市',
						type: 'pie',
						radius: ['0%', '60%'],
						labelLine: {
							length: 30
						},
						label: { show: true, position: 'outside', color: '#000', fontSize: 12, formatter: '{b},{d}' + '%', },
						data: serdata1,
					}
				]
			};
			chart.setOption(option);
		},




		shareholderPie($el, data) {
			var xdata = [], serdata = [];
			for (var i = 0; i < data.length; i++) {
				xdata.push(data[i].name);
				serdata.push(data[i].value);
			}
			var chart = echarts.init(document.getElementById($el));
			var option = {
				title: {
					text: "",
					left: 'center',
					bottom: 10,
					textStyle: {
						color: '#000',
						fontSize: 16
					}
				},
				tooltip: {
				},
				color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				// legend: {
				//   data: ['Top 10股东持股比例'],
				// 		bottom:10,
				// },
				grid: {
					x: 300,
					y: 10,
					x2: 50,
					y2: 30,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: true,
					position: 'right',
					valueAnimation: true,
					color: '#737373',
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: true
					},
					axisLabel: {
						fontSize: 13,
						color: '#737373'
					}
				},
				yAxis: {
					type: 'category',
					inverse: true,//倒叙
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					},
					data: xdata,
					axisLabel: {
						fontSize: 13,
						color: '#737373',
						formatter: function (params) {  //标签太长换行
							var newParamsName = ""; // 最终拼接成的字符串
							var paramsNameNumber = params.length; // 实际标签的个数
							var provideNumber = 22; // 每行能显示的字的个数
							var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
							/**
							 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
							 */
							// 条件等同于rowNumber>1
							if (paramsNameNumber > provideNumber) {
								/** 循环每一行,p表示行 */
								for (var p = 0; p < rowNumber; p++) {
									var tempStr = ""; // 表示每一次截取的字符串
									var start = p * provideNumber; // 开始截取的位置
									var end = start + provideNumber; // 结束截取的位置
									// 此处特殊处理最后一行的索引值
									if (p == rowNumber - 1) {
										// 最后一次不换行
										tempStr = params.substring(start, paramsNameNumber);
									} else {
										// 每一次拼接字符串并换行
										tempStr = params.substring(start, end) + "\n";
									}
									newParamsName += tempStr; // 最终拼成的字符串
								}

							} else {
								// 将旧标签的值赋给新标签
								newParamsName = params;
							}
							//将最终的字符串返回
							return newParamsName
						}
					}
				},
				series: [{
					name: '',
					data: serdata,
					type: 'bar',
					label: { 							//图表顶部显示数据
						normal: {
							show: true,
							formatter: '{@score}' + '%'
						}
					},
				}]
			};
			chart.setOption(option);


		},
		piefunOld(el, data) {
			var mypiechart = echarts.init(document.getElementById(el));
			var option = {
				title: {
					text: '',
					left: 'center',
					top: 10,
				},
				//悬浮显示
				tooltip: {
					trigger: 'item'
				},
				// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				//图例
				legend: {
					show: false,
					left: 'center',
					bottom: 10,
					itemWidth: 6, itemHeight: 6
				},

				series: [{
					name: '',
					type: 'pie',
					radius: '60%',
					data: data,
					label: { show: true, position: 'outside', color: '#000', fontSize: 12, formatter: '{b},{d}' + '%', },
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			mypiechart.setOption(option);
		},
		landpiefun(el, data, type, type1, title, unit) {
			var mypiechart = echarts.init(document.getElementById(el));
			var serdata = [], serdata1 = [], ortherCount = 0;

			for (var i = 0; i < data.length; i++) {
				let sizen = 0;
				if (type1 == 1) {
					if (type == 'land') {
						sizen = data[i].size.toFixed(2);
					} else {
						sizen = (data[i].money / 10000).toFixed(2);
					}
				} else if (type1 == 2) {
					sizen = data[i].value;
				}

				serdata.push({ name: data[i].name, value: sizen * 1 })
			}
			if (type == 'land') {//拿地城市信息需要排序并列出其他城市 投资项目城市不需要排序并额外提出另外城市
				serdata = this.sortKey(serdata, 'value');
				for (var i = 0; i < serdata.length; i++) {
					if (i < 10) {
						serdata1.push(serdata[i]);
					} else {
						ortherCount = serdata[i].value + ortherCount;
					}
				}
				if (ortherCount > 0) {
					serdata1.push({ name: "其他城市", value: ortherCount.toFixed(2) * 1 });
				}
			} else {
				serdata1 = serdata;
			}

			var option = {
				title: {
					text: '',
					left: 20,
					textStyle: { fontSize: 16, color: "#666" },
					top: 10,
				},
				//悬浮显示
				tooltip: {
					trigger: 'item',
					formatter: function (params) {
						// console.log(params)
						let rethtml = params.marker + params.name + " : " + params.value + ' ' + unit;
						return rethtml;
					},
				},
				// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				//图例
				legend: {
					show: false,
					left: 'center',
					bottom: 10,
					itemWidth: 6, itemHeight: 6
				},

				series: [{
					name: '',
					type: 'pie',
					radius: '60%',
					data: serdata1,
					label: { show: true, position: 'outside', color: '#000', fontSize: 12, formatter: '{b}:{d}%', },
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			mypiechart.setOption(option);
		},
		//type用于区分项目和拿地 他们的date值名字不一样 type1用于区分面积/金额和数量 他们的参数名字也不一样
		lineReturnData(data, type, type1) {

			//折线图 将时间提取出来 
			var serdata = [];//todo 每个月要进行更新 updatetime
			let yeararry = ['2023-02', '2023-03', '2023-04', '2023-05', '2023-06', '2023-07', '2023-08', '2023-09', '2023-10', '2023-11', '2023-12', '2024-01',];
			let yearstr = yeararry.join("%");
			var yeardata = [];
			for (var i = 0; i < yeararry.length; i++) {
				yeardata.push({ name: yeararry[i], value: 0 });
			}
			if (type1 > 2) {
				//近期 从现实推算到一年的数据 

				for (var i = 0; i < data.length; i++) {
					if (type == 'land') {
						data[i].datetime = data[i].time.substring(0, 7);
						data[i].Linevalue = data[i].size;
					} else if (type == 'project') {
						data[i].datetime = data[i].date.substring(0, 7);
						data[i].Linevalue = data[i].money / 10000;
					} else if (type == 'finance') {
						data[i].datetime = data[i].date.substring(0, 7);
						data[i].Linevalue = data[i].money / 10000;
					}
				}
				data = data.filter(list => {
					return yearstr.indexOf(list.datetime) > -1;
				})
				console.log('yeardata0', data)
			} else {
				for (var i = 0; i < data.length; i++) {
					if (type == 'land') {
						data[i].datetime = data[i].time.substring(0, 4);
						data[i].Linevalue = data[i].size;
					} else if (type == 'project') {
						data[i].datetime = data[i].date.substring(0, 4);
						data[i].Linevalue = data[i].money / 10000;
					} else if (type == 'finance') {
						data[i].datetime = data[i].date.substring(0, 4);
						data[i].Linevalue = data[i].money / 10000;
					}
				}
			}


			var Num = [0];//存储数据出现的次数
			var str = [0];//存储不重复的数据， 
			var amountArry = [0];//存储不重复的数据， 
			var x = 0;
			for (var i = 0; i < data.length; i++) {
				var temp = data[i].datetime//将要统计的数据赋值给temp
				var Linevalue1 = data[i].Linevalue;
				var Num1 = 1;
				for (var j = i + 1; j < data.length; j++) {
					if (temp == data[j].datetime) {//若数组后续中的数据与temp相同时，进行该代码段
						Num1++;//项目/拿地数量叠加
						Linevalue1 += data[j].Linevalue;//拿地面积和项目金额叠加 上面已经将参数值统一了
					}
				}
				var answer = (str.indexOf(temp) > -1)//判断str数组中是否含有temp数据，存在返回true否则false
				if (!answer) {//若数据不存在时，进行此程序，将数据存储起来
					str[x] = temp//str与Num的下角标互相对应
					Num[x] = Num1
					amountArry[x] = Linevalue1;
					x++
				}
			}
			// console.log("数组str的长度为："+str.length+"</br>"); 
			for (var k = 0; k < str.length; k++) {
				// console.log("字符："+str[k]+" 出现次数为："+Num[k]+"</br>");  
				if (type1 == 1 || type1 == 3) {
					serdata.push({ name: str[k], value: amountArry[k].toFixed(1) });
				} else if (type1 == 2 || type1 == 4) {
					serdata.push({ name: str[k], value: Num[k] });
				}
				this.sortKey2(serdata, 'name');
			}
			if (type1 > 2) {
				for (var i = 0; i < serdata.length; i++) {
					let serMonth = serdata[i].name;
					for (var d = 0; d < yeardata.length; d++) {
						if (serMonth == yeardata[d].name) {
							yeardata[d].value = serdata[i].value;
						}
					}
				}
				serdata = yeardata;
			}
			console.log('serdata', serdata)
			return serdata;
		},
		linechartfun(el, data, type, type1, title, unit) {
			var mylinechart = echarts.init(document.getElementById(el));
			var xdata = [], ydata = [];
			if (type != 'zzq' && type != 'zzzs') {
				var serdata = this.lineReturnData(data, type, type1);
				// this.yearsLand = serdata;//用来存大模型解析需要用到的数据
			} else {
				var serdata = this.sortKey2(data, 'name');
			}
			var echartitle = (type == 'zzq' || type == 'zzzs') ? ('历年' + title) : '';
			for (var n = 0; n < serdata.length; n++) {
				xdata.push(serdata[n].name);
				ydata.push(serdata[n].value);
			}
			var timeunit = type1 > 2 ? '月' : '年';
			// console.log(xdata,ydata); 
			var option = {
				title: {
					text: echartitle,
					left: 'center',
					top: 10,
				},
				color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				// tooltip: {
				// 	trigger: 'item'
				// },
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					},
					formatter: function (params) {
						let rethtml = params.marker + params.name + timeunit + title + "：" + params.value + unit;
						return rethtml;
					}
				},
				legend: {
					show: true,
					bottom: 10,
				},
				label: { show: true },
				xAxis: {
					type: 'category',
					data: xdata,
				},
				yAxis: {
					type: 'value',
					name: title.substring(2, 4) + '（' + unit + '）',
				},
				series: [
					{
						name: '',
						data: ydata,
						type: 'line',
						smooth: true
					}
				]
			};
			mylinechart.setOption(option);
		},
		jinliruBar($el, data) {
			var chart = echarts.init(document.getElementById($el));
			var _this = this;
			let option = {
				title: {
					text: data.name, bottom: 5, left: 'center',
					textStyle: { fontWeight: "normal", fontSize: 16 }
				},
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					},
					formatter: function (params) {
						let rethtml = params.marker + params.name + "年" + data.name + "：" + params.value + data.unit;
						return rethtml;
					}
				},
				xAxis: {
					type: 'category',
					data: data.date,
				},
				color: _this.colors,
				yAxis: {
					type: 'value',
					name: '单位：' + data.unit,
				},
				series: [{
					data: data.data,
					type: 'bar',
					barWidth: 24,
				}]
			};
			chart.setOption(option);
		},
		//经营状况雷达图
		jyzkRadar(el, data) {
			// console.log(el,data);
			var myChart = echarts.init(document.getElementById(el));
			var _this = this, valueData = [], namedata = [], serdata = [];
			for (var i = 0; i < data.label.length; i++) {
				namedata.push({ name: data.label[i], max: 5 })
			}
			var option = {
				title: {
					text: ''
				},
				color: _this.colors,
				legend: {
					show: true, bottom: 0, left: 'center',
				},
				tooltip: { show: true },
				radar: {
					radius: 150,
					axisName: { fontSize: 14, color: '#666' },
					splitArea: {
						//分割区域的样式	
						areaStyle: { color: ['#fff', '#fff', '#fff', '#fff', '#fff'], opacity: 0.2, }
					},
					// splitLine:{lineStyle:{type:'dashed'}},
					axisLine: { show: true, color: "#eee" },  //设置所有刻度线不显示
					indicator: namedata
				},
				series: [{
					name: data.y2021.text,
					type: 'radar', label: { show: true },
					data: [{ value: data.y2021.data, name: data.y2021.text }],  //[60,50,30,40,20,30]
					areaStyle: { normal: { color: _this.colors[0], opacity: 0.2, shadowColor: '#000', } },
					lineStyle: { normal: { color: 'blue', width: 2 } },//折线样式
					symbol: "none", // 去掉图表中各个图区域的边框线拐点
				}, {
					name: data.y2022.text,
					type: 'radar', label: { show: true },
					data: [{ value: data.y2022.data, name: data.y2022.text }],  //[60,50,30,40,20,30]
					areaStyle: { normal: { color: '#f60', opacity: 0.2, shadowColor: '#000', } },
					lineStyle: { normal: { color: '#f60', width: 2 } },//折线样式
					symbol: "none", // 去掉图表中各个图区域的边框线拐点
				}]
			};
			myChart.setOption(option);
		},
		//雷达图招商画像
		holdradarFun(el, data) {
			// console.log('holdradarFun',data)
			var charPie3currentIndex = 0, isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var myChart = echarts.init(document.getElementById(el));
			var _this = this, valueData = [], namedata = [], serdata = [];
			for (var i = 0; i < data.length; i++) {
				// console.log(data[i].name,data[i].text)
				data[i].id = data[i].name;
				data[i].name = data[i].text;
				data[i].max = 100;
				if (data[i].id.substring(3) == '00000') {
					// namedata.push(nobj); 
					namedata.push(data[i])
					valueData.push(data[i].value);
				}
			}
			namedata.unshift(namedata[namedata.length - 1]);
			valueData.unshift(valueData[valueData.length - 1]);
			namedata.splice(namedata.length - 1, 1);
			valueData.splice(valueData.length - 1, 1);
			var hxname = this.curWebsite.hxname;
			//console.log(namedata)
			var option = {
				title: {
					text: ''
				},
				legend: {
					show: false,
				},
				tooltip: { show: true },
				radar: {
					radius: 150,
					axisName: { fontSize: 14, color: '#666' },
					splitArea: {
						//分割区域的样式	
						areaStyle: { color: ['#fff', '#fff', '#fff', '#fff', '#fff'], opacity: 0.2, }
					},
					// splitLine:{lineStyle:{type:'dashed'}},
					axisLine: { show: false, color: "#eee" },  //设置所有刻度线不显示
					indicator: namedata
				},
				series: [{
					name: hxname,
					type: 'radar', label: { show: true },
					data: [{ value: valueData, name: hxname }],  //[60,50,30,40,20,30]
					areaStyle: { normal: { color: 'rgba(58, 86, 142, .5)', opacity: 0.2, shadowColor: '#000', } },
					lineStyle: { normal: { color: 'rgba(58, 86, 142, .2)', width: 1 } },//折线样式
					symbol: "none", // 去掉图表中各个图区域的边框线拐点
				}]
			};
			myChart.setOption(option);
		},
		//拿地项目地图分布 'landMapInfor',this.landInfo.cityList,'land',type,title
		mapSymbolSize(val, sorti, sizedata) {
			// console.log( sizedata[sorti]); 
			return sizedata[sorti];
			/*
			function (val) {
				if(type1 == 2){
					var ddd=8,val1=val[2];
					if(val1<11 && val1 > 1){
						ddd=8+parseInt(val1/2);
					}else if(val1 > 10){
						var snum=parseInt(val1/10); 
						ddd=13+snum;
					}
				}else{
					var ddd=8,val1=val[2]/10;
					if(val1<11 && val1 > 1){
						ddd=8+parseInt(val1/2);
					}else if(val1 > 10){
						var snum=parseInt(val1/10); 
						ddd=13+snum;
					}
				}
				
				// console.log(val,ddd);
				 return ddd;
			}*/
		},
		chianmapFun(el, data, type, type1, title) {
			if (data.length < 1) {
				return;
			}
			// console.log('拿地项目地图分布',el,data);
			var myChart = echarts.init(document.getElementById(el));
			myChart.showLoading({
				text: 'loading',
				color: '#3A568E',
				textColor: '#000',
				maskColor: 'rgba(255, 255, 255, 1)',
				zlevel: 1,
			});
			var loadedDataURL = 'map/china.json';
			// 注意引入版本 
			var geoCoordMap = this.$geoJson;
			var _this = this;
			$.getJSON(loadedDataURL, function (geoJson) {
				// 注册地图名字(tongren)和数据(geoJson) 
				echarts.registerMap('china', geoJson);
				var scaData = [], maptitle = '', symbolSizeData = [], testdata = [];
				for (var i = 0; i < data.length; i++) {
					var geoCoord = geoCoordMap[data[i].name];
					// console.log(geoCoord)
					if (geoCoord) {
						var value1 = [], scdataSm = {};
						if (type1 == 2) {
							value1 = geoCoord.concat(data[i].value);//通过数量分布显示光圈大小
						} else {
							if (type == 'land') {
								value1 = geoCoord.concat(data[i].size.toFixed(2))//通过拿地面积分布显示光圈大小
							} else {
								value1 = geoCoord.concat((data[i].money / 10000).toFixed(2))//通过项目金额分布显示光圈大小
							}
						}
						if (type == 'land') {
							scdataSm = { name: data[i].name, value: value1, areaId: data[i].areaId, money: data[i].money, num: data[i].value, size: data[i].size.toFixed(2) }
						} else if (type == 'project') {
							scdataSm = { name: data[i].name, value: value1, areaId: data[i].areaId, money: (data[i].money / 10000).toFixed(2), num: data[i].value, }
						}
						scaData.push(scdataSm);
					}

				}
				var repeatNum = 0, a1 = [{ value: scaData[0].value[2], index: 0 }];
				for (var i = 1; i < scaData.length; i++) {
					if (scaData[i].value[2] != scaData[i - 1].value[2]) {
						repeatNum++;
					}
					var a2 = { value: scaData[i].value[2], index: repeatNum };
					a1.push(a2);
				}

				if (title.indexOf('面积') > 0) {
					// console.log('repeatNum',repeatNum)
					for (var i = 0; i < a1.length; i++) {
						let size = (repeatNum - a1[i].index + 1) * 1;
						if (repeatNum < 5) {
							// console.log(repeatNum,'<5')
							size = (repeatNum - a1[i].index + 1) * 3;
						} else if (4 < repeatNum && repeatNum < 10) {
							size = (repeatNum - a1[i].index + 1) * 2;
						} else if (9 < repeatNum && repeatNum < 15) {
							size = (repeatNum - a1[i].index + 1) * 1.5;
						} else if (14 < repeatNum && repeatNum < 25) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.6)
						} else if (24 < repeatNum && repeatNum < 35) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.5);
						} else if (34 < repeatNum && repeatNum < 45) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.4);
						} else if (44 < repeatNum && repeatNum < 55) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.3);
						} else if (54 < repeatNum && repeatNum < 99) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.2);
						} else if (98 < repeatNum) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.2);
						}
						symbolSizeData.push(size);
					}
				} else {
					for (var i = 0; i < a1.length; i++) {
						let size = (repeatNum - a1[i].index + 1) * 1;
						if (repeatNum < 5) {
							size = (repeatNum - a1[i].index + 1) * 2 + 8;
						} else if (4 < repeatNum && repeatNum < 10) {
							size = (repeatNum - a1[i].index + 1) * 2 + 3;
						} else if (9 < repeatNum && repeatNum < 15) {
							size = (repeatNum - a1[i].index + 1) * 2;
						} else if (14 < repeatNum && repeatNum < 25) {
							size = parseInt((repeatNum - a1[i].index + 1) * 1.8)
						} else if (24 < repeatNum && repeatNum < 35) {
							size = parseInt((repeatNum - a1[i].index + 1) * 1.3);
						} else if (34 < repeatNum && repeatNum < 45) {
							size = parseInt((repeatNum - a1[i].index + 1) * 1);
						} else if (44 < repeatNum && repeatNum < 55) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.8);
						} else if (54 < repeatNum && repeatNum < 99) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.6);
						} else if (98 < repeatNum) {
							size = parseInt((repeatNum - a1[i].index + 1) * 0.5);
						}
						symbolSizeData.push(size);
					}
				}
				var option = {
					backgroundColor: '#fff',
					title: {
						text: title,
						left: 'center', top: 80,
						textStyle: {
							color: '#666',
							fontSize: 16
						}
					},
					tooltip: {           //提示框组件
						trigger: 'item',
						formatter: function (params) {
							// console.log(params)
							return params.name;
						},
						show: true,
					},

					legend: {            //图例
						orient: 'vertical', show: false,
						y: 'bottom',
						x: 'right',
					},
					geo: {
						map: "china",
						silent: true,
						// layoutCenter: ['49%', '49%'],
						layoutSize: '100%',
						roam: false,
						center: [105.87, 38],
						zoom: 1,
						label: { show: true, textStyle: { color: '#fff' } },
						itemStyle: {
							normal: {
								areaColor: "#2e579d",
								borderColor: "#fff"
							},
							emphasis: {
								areaColor: "#fff"
							}
						}
					},
					series: [
						{
							name: '',
							type: 'effectScatter',
							coordinateSystem: 'geo',
							data: scaData,    //选取从 start 到数组结尾的所有元素，该方法并不会修改数组，而是返回一个子数组 
							symbolSize: function (val, ser) {
								// console.log(val[2],title,ser.dataIndex)
								return symbolSizeData[ser.dataIndex];
								// return _this.mapSymbolSize(val,ser.dataIndex,symbolSizeData);
							},
							showEffectOn: 'render',
							rippleEffect: {
								brushType: 'stroke'
							},
							tooltip: {
								show: true,
								formatter: function () { },
							},
							hoverAnimation: true,
							label: {
								normal: {
									formatter: '{b}:{@2}',
									position: 'right',
									show: false
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: '#f4e925',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							zlevel: 1
						},
					]
				};
				if (type == 'land') {
					option.series[0].tooltip.formatter = function (params) {
						var result = '<h3 style="font-size:15px;line-height:20px;margin-bottom:5px">' + params.name + '</h3>';
						if (!isNaN(params.data.money)) {
							result = result + '<div style="line-height:20px">拿地面积：' + params.data.size + ' 亩<br>拿地金额：' + params.data.money + '万元<br>拿地记录：' + params.data.num + ' 条</div>';
						}
						// console.log(params);
						return result;
					}
				} else if (type == 'project') {
					option.series[0].tooltip.formatter = function (params) {
						var result = '<h3 style="font-size:15px;line-height:20px;margin-bottom:5px">' + params.name + '</h3>';
						if (!isNaN(params.data.money)) {
							result = result + '<div style="line-height:20px">投资项目数：' + params.data.value[2] + ' 个<br>投资金额：' + params.data.money + ' 亿元</div>';
						}
						// console.log(params);
						return result;
					}
				}
				myChart.hideLoading();
				myChart.setOption(option);

			})
		}


	}
}
</script>

<style>
.text-tdjs {
	height: 90px;
	border: 1px solid red;
	display: inline-block;
	text-overflow: ellipsis;
	overflow: hidden;
	position: relative;
	/* white-space:nowrap; */
}

.detail-tdjs {
	position: absolute;
	top: 0px;
	right: 0px;
}
</style>
